import React, { Component } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NavLink } from 'react-router-dom';
import momentJalaali from 'moment-jalaali';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import InputMask from 'react-input-mask';
import DatePicker from 'react-datepicker2';
import Select from 'react-select';

export default class Base extends Component {
    constructor(props) {
        super(props);
    }
    apiFailInModal() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="panel panel-info center-block" style={{ "max-width": "none", "border": "none" }} >
                            <div className="modal-header modal-header-info" style={{ "padding": "0px" }} >
                                <button type="button" className="close" aria-label="Close" onClick={e => this.closeMe()}><span aria-hidden="true">×</span></button>
                                <h4 class="modal-title"><span>خطا</span></h4></div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <p>{this.state.data.message}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="hand btn btn-primary" onClick={e => this.save(e, false)} >برگشت</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    getStuffInventory(items = []) {
        //{ stuffId: null, warehouseId: null, ownerId: null, warehouseLocationId: null }
        return new Promise((resolve, reject) => {
            this.httpPost("api/v1/stuff/inventory", { items })
                .then(data => {
                    if (data.status === -1) resolve([]);
                    resolve(data.records);
                });
        })
    }
    T(key) {
        if (!this.state.translate) return key;

        var t = this.state.translate.find(f => f.key == key);
        if (!t) return key;
        return t.text;
    }
    getTranslates(parameters = { component: '' }) {
        this.state.translate = [];
        return new Promise((resolve, reject) => {
            this.httpPost("api/v1/translate/list", {
                component: parameters.component,
                paging: false,
                counting: false
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";

                    if (data.status === 1) { 
                        this.setState({ translate: data.records });
                    }
                    else {
                    }

                    resolve(null);
                });
        })
    }
    getUiSettings() {
        return {
            hiddenFields: []
        }
    }
    getQueryString(f) {
        f = f.toLowerCase();
        var v = '';
        if (window.location.href.includes("?")) {
            var q = window.location.href.split("?")[1];
            q.split("&").forEach(qq => {
                if (qq.split("=")[0].toLowerCase() == f) v = qq.split("=")[1];
            });
        }
        return v;
    }
    getSiteDomain() {
        return "";
    }
    getUiSettingConfigs(parameters = { formName: '' }) {
        return new Promise((resolve, reject) => {
            this.httpPost("api/v1/companyuisetting/get/configs", {
                formName: parameters.formName
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    this.state.innerStatus = data.innerStatus;
                    if (data.status === 1) {
                        if (!this.isNull(data.hiddenFields))
                            this.state.uiSettings.hiddenFields = data.hiddenFields;
                        this.setState({ uiSettings: this.state.uiSettings });
                    }
                    else {
                    }

                    resolve(null);
                });
        })
    }
    getFieldVisable(fieldName) {
        if (this.isNull(this.state.uiSettings)) return true;
        if (this.isNull(this.state.uiSettings.hiddenFields)) return true;
        if (this.state.uiSettings.hiddenFields.includes(fieldName)) return false;
        return true;
    }
    convertNewLines(e) {
        if (this.isNull(e)) return e;
        return e.replace(/\n/g,'<br/>')
    }
    hasPermission(menuId) {
        if (this.isEmpty(this.state.data.global.user.userPermissions)) return false;

        if (this.state.data.global.user.userPermissions === 'owner') return true;

        var permission = '[' + menuId +']';
        if (this.state.data.global.user.userPermissions.includes(permission)) return true;

        return false;
    }
    htmlToString(html) {
        //تو حالت ssr تولید خطا میکنه و بایستی رد بکنه
        try {
            var div = document.createElement('div');
            div.innerHTML = html;
            var text = div.textContent || div.innerText || '';
            return text;
        } catch (err) {
            return html;
        }
    }
    UserRolString(r) {
        if (r == 1) return "مدیر";
        if (r == 2) return "کاربر";
        return "";
    }
    createCrm(e, source, phone, name = '', email = '') {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/crm/case/create", {
            source,
            phone,
            email,
            name,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.innerStatus = data.innerStatus;
                if (data.status === 1) {
                    this.showSuccessMessage("پرونده پیگیری مشتری ایجاد گردید است و میتوانید پیگیری نمایید");
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    loadCitiesOptions(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getcities/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name,
                            provinceId: _record.provinceId
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    loadSkillsOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/common/getskills/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    loadAccountOptions(inputValue, callback, type, parentId=null, tafsilType=0,addNew=0,relatedTafsilAccountId=null) {
        var organizationId = window.organizationId;

        var tafsilTypes = [];
        if (typeof (tafsilType) !== 'object') tafsilTypes = [tafsilType];
        else tafsilTypes = tafsilType;

        setTimeout(() => {
            fetch("/api/v1/common/getaccounts/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    "type": type,
                    "tafsilTypes": tafsilTypes,
                    relatedTafsilAccountId,
                    organizationId,
                    companyId: organizationId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
							fullCode: _record.fullCode,
							value: _record.id,
							label: _record.fullCode + "-" + _record.title + "-" + this.money(_record.balance) + this.state.data.global.company.currencyUnit,
							accountTafsilType: _record.accountTafsilType,
							id: _record.id,
							moeinDetailed: _record.detailed,
							moeinFollow: _record.follow,
							moeinCurrency: _record.currency,
							moeinCounting: _record.counting,
							moeinSolutionMostSelect: _record.solutionMostSelect
                        }));
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: 'افزودن تفصیل جدید',
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadChequeNumbersOptions(inputValue, callback, bankAccountId) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getchequenumbers/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId,
                    bankAccountId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.chequeId,
                            label: _record.number,
                            number: _record.number
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    loadChequeInfosOptions(inputValue, callback, type = null, status = null) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch('/api/v1/common/getchequeinfos/', {
                method: 'post',
                body: JSON.stringify({
                    term: inputValue,
                    organizationId,
                    companyId: organizationId,
                    type,
                    status
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((response) => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records;
                    }
                    callback(items);
                });
        }, 50);
    }
    loadConstantsOptions(inputValue, callback, type, addNewConstant = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getconstants/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    type,
                    organizationId,
                    companyId: organizationId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name,
                        }));
                    }
                    if (addNewConstant === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن گروه جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadContractsOptions(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getcontracts/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    "status": 4,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            manCompanyId: _record.manCompanyId,
                            f1: _record.f1,
                            f5: _record.f5,
                            f6: _record.f6,
                            f7: _record.f7,
                            f13: _record.f13,
                            f14: _record.f14,
                            f15: _record.f15,
                            label: "قرارداد شماره " + _record.contractNumber + " متعلق به " + _record.manCompanyName + " با کد ملی " + _record.manCompanyNationalId
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    loadContractingContractsOptions(inputValue, callback) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch('/api/v1/common/getcontractingcontracts/', {
                method: 'post',
                body: JSON.stringify({
                    term: inputValue,
                    organizationId,
                    companyId: organizationId,
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((response) => {
                    let items = response.records;
                    callback(items);
                });
        }, 50);
    }
    loadPersonsOptions(inputValue, callback, addNewPerson = 0, personType = 0, customerType = 0, requestFrom= '',labelFields='*',showBalance=true) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getpersons/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId,
                    personType: personType,
                    customerType: customerType,
                    requestFrom: requestFrom
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: (labelFields != '*' ? (
                                (labelFields.includes('[code]') ? _record.code + "-" : '') +
                                _record.name +
                                (labelFields.includes('[mobile]') ? "-" + _record.mobile : '') +
                                (labelFields.includes('[nationalId]') ? "-" + _record.nationalId : ''))
                                :
                                (_record.code + "-" + _record.name + "-" + _record.mobile + "-" + _record.nationalId)
                            ) + (showBalance ? ("-" + this.money(_record.balance) + this.state.data.global.company.currencyUnit) : ''),
                            code: _record.code
                        }));
                    }
                    if (addNewPerson === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن شخص جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadWarehouseLocationsOptions(inputValue, callback, warehouseId) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch('/api/v1/common/getwarehouselocations/', {
                method: 'post',
                body: JSON.stringify({
                    term: inputValue,
                    organizationId,
                    companyId: organizationId,
                    warehouseId,
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((response) => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records;
                    }
                    callback(items);
                });
        }, 50);
    }
    loadCurriculumTypesOptions(inputValue, callback) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch('/api/v1/curriculumtype/lookup/', {
                method: 'post',
                body: JSON.stringify({
                    term: inputValue,
                    organizationId,
                    companyId: organizationId,
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((response) => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records;
                    }
                    callback(items);
                });
        }, 50);
    }
    loadCurriculumLevelsOptions(inputValue, callback) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch('/api/v1/curriculumlevel/lookup/', {
                method: 'post',
                body: JSON.stringify({
                    term: inputValue,
                    organizationId,
                    companyId: organizationId,
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((response) => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records;
                    }
                    callback(items);
                });
        }, 50);
    }
    loadRestaurantTablesOptions(inputValue, callback) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch('/api/v1/common/getrestauranttables/', {
                method: 'post',
                body: JSON.stringify({
                    term: inputValue,
                    organizationId,
                    companyId: organizationId,
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((response) => {
                    let items = response.records;
                    callback(items);
                });
        }, 50);
    }
    loadFactorsOptions(inputValue, callback, type, manualRemittance = 0, orderingId = null) {
        // اگر عدد بود، به آرایه تبدیل کن
        if (!Array.isArray(type)) {
            type = [type];
        }
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getfactors/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId,
                    type,
                    manualRemittance,
                    orderingId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records;
                    }
                    callback(items);
                })
        }, 50);
    }
    loadMovementsOptions(inputValue, callback) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getmovements/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records;
                    }
                    callback(items);
                })
        }, 50);
    }
    loadProductionLinesOptions(inputValue, callback,timeSheetHeaderId=null) {

        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getproductionlines/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId,
                    timeSheetHeaderId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = response.records;
                    callback(items);
                })
        }, 50);
    }
    loadMeetingResualtOptions(inputValue, callback, addNew = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getmeetingresults/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = response.records;
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadOrganPositionOptions(inputValue, callback, addNew = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getorganpositions/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = response.records;
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadOrganWorkingGroupOptions(inputValue, callback, addNew = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getorganworkinggroups/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = response.records;
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadDocumentTemplatesOptions(inputValue, callback, addNew = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getdocumenttemplates/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    companyId: organizationId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records;
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadCrmCaseStatusOptions(inputValue, callback, teamId) {
        setTimeout(() => {
            fetch("/api/v1/common/getcrmcasestatus/", {
                method: "post",
                body: JSON.stringify({
                    crmTeamId: teamId,
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = response.records
                    callback(items);
                })
        }, 50);
    }
    loadExcelImportTemplatesOptions(inputValue, callback, type) {
        setTimeout(() => {
            fetch("/api/v1/excelimporttemplate/list/", {
                method: "post",
                body: JSON.stringify({
                    phrase: inputValue,
                    type,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.forEach(i => {
                            items.push({
                                value: i.id,
                                label: i.title,
                                configs: i.configs
                            })
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadCrmTeamsOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/common/getcrmteams/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = response.records
                    callback(items);
                })
        }, 50);
    }
    loadCrmSourcesOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/common/getcrmsources/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = response.records
                    callback(items);
                })
        }, 50);
    }
    loadSolutionUsersOptions(inputValue, callback, solutionId) {
        setTimeout(() => {
            fetch("/api/v1/common/getsolutionusers/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    solutionId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name,
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    loadBuildingUnitCategoriesOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/common/getunitcategories/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = response.records
                    callback(items);
                })
        }, 50);
    }
    loadCompanyResumesOptions(inputValue, callback, addNew = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getcompanyresumes/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records;
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن شرکت جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadSolutionWorkFlowsOptions(inputValue, callback, solutionId, addNew = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getsolutionworkflows/", {
                method: "post",
                body: JSON.stringify({
                    solutionId,
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name,
                        }));
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن نقش جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadSolutionsOptions(inputValue, callback, addNew = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getsolutions/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records;
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadSolutionRolesOptions(inputValue, callback, solutionId, addNew = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getsolutionroles/", {
                method: "post",
                body: JSON.stringify({
                    solutionId,
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name,
                        }));
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن نقش جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    };
    loadBuildingsOptions(inputValue, callback, addPerson = 0) {
        setTimeout(() => {
            fetch("/api/v1/common/getbuildings/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name,
                        }));
                    }
                    if (addPerson === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن ساختمان جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    };
    loadExpensesOptions(inputValue, callback, type, addNew = 0) {
        var types = [];
        if (Array.isArray(type)) {
            type.forEach(f => types.push(f));
        }
        else {
            types = [type];
        }
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getexpenses/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    "type": types,
                    "organizationId": organizationId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title,
                        }));
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن نوع جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadBillExpensesOptions(inputValue, callback, buildingId = this.getDefaultGuid(), addNew = 0) {
        setTimeout(() => {
            fetch("/api/v1/common/getbillexpenses/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    "buildingId": buildingId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name,
                            billExpenseType: _record.billExpenseType
                        }));
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن نوع جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadBillExpenseUnitsOptions(inputValue, callback, buildingId = this.getDefaultGuid(), addNew = 0, unitId = this.getDefaultGuid(), settlement = null) {
        setTimeout(() => {
            fetch("/api/v1/common/getbillexpenseunits/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    "buildingId": buildingId,
                    "unitId": unitId,
                    settlement
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name,
                        }));
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن نوع جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    };
    loadBuildingUnitsOptions(inputValue, callback, buildingId = this.getDefaultGuid(), addNew = 0) {
        setTimeout(() => {
            fetch("/api/v1/common/getbuildingunit/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    "buildingId": buildingId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name,
                        }));
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن نوع جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    };
    loadBankAccountsOptions(inputValue, callback, addNew = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getbankaccounts/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.code + "-" + _record.name,
                            code: _record.code
                        }));
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن حساب بانک جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    };
    loadBanksOptions(inputValue, callback, addNew = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getbanks/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records;
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن بانک جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadChequePrintTemplatesOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/chequeprinttemplate/list/", {
                method: "post",
                body: JSON.stringify({
                    phrase: inputValue,
                    page: 1,
                    count: 20
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.forEach(f => {
                            items.push({
                                value: f.id,
                                label: f.title,
                            })
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadCashdesksOptions(inputValue, callback, addNew = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getcashdesks/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.code + "-" + _record.name,
                            code: _record.code
                        }));
                    }
                    if (addNew === 1) {
                        items.push({
                            value: -1,
                            label: "افزودن صندوق جدید",
                        });
                    }
                    callback(items);
                })
        }, 50);
    }
    loadStuffsOptions(inputValue, callback, type = 0, stuffWichName = 0) {
        var types = [];
        if (typeof (type) !== 'object') {
			if(type !== 0) types = [type];
		}
        else types = type;

        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getstuffs/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId,
                    types,
                    stuffWichName
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.code + "-" + _record.name,
                            price: _record.price,
                            unitId: _record.unitId,
                            unitName: _record.unitName,
                            taxRate: _record.taxRate,
                            code: _record.code,
                            name: _record.name,
                            type: _record.type,
                            modulusUnitName: _record.modulusUnitName,
                            modulusUnitId: _record.modulusUnitId,
                            modulusUnitRate: _record.modulusUnitRate,
                            defaultAmount: _record.defaultAmount,
                            description: _record.description,
                            warehouseId: _record.warehouseId,
                            warehouseName: _record.warehouseName,
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    loadUnitsOptions(inputValue, callback) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getunits/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = response.records;
                    callback(items);
                })
        }, 50);
    }
    loadWarehousesOptions(inputValue, callback, requestFrom = '', type = 0) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch("/api/v1/common/getwarehouses/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    organizationId,
                    companyId: organizationId,
                    requestFrom,
                    type
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title,
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    loadUsersOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/common/getusers/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name + " - " + _record.mobile
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    loadUserGroupsOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/common/getusergroups/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    loadAnnualsOptions(inputValue, callback) {
        setTimeout(() => {
            fetch('/api/v1/common/getannuals/', {
                method: 'post',
                body: JSON.stringify({
                    term: inputValue,
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((response) => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records;
                    }
                    callback(items);
                });
        }, 50);
    }
    loadBranchesOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/branch/list/", {
                method: "post",
                body: JSON.stringify({
                    count: 20,
                    page: 1,
                    "phrase": inputValue,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    loadStudentsOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/common/getstudents/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name + " - " + _record.mobile
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    loadStudentCategoriesOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/common/getstudentcategories/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.name
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    showComponents(params = { component: '' }) {
        if (this.isNull(params)) return;
        if (this.isNull(params.component)) return;
        this.setState({ popupComponent: params.component });
    }
    renderPopupComponent() {
        if (this.isNull(this.state.popupComponent)) return null;

        return this.state.popupComponent;
    }
    closePopupComponent() {
        this.setState({ popupComponent: null });
    }
    closeMe() {
        if (!this.isNull(this.state.caller.addKeyDown)) this.state.caller.addKeyDown();
        this.state.caller.closePopupComponent();
    }
    addKeyDown() { document.addEventListener("keydown", this.keyDownFunction, false); }
    removeKeyDown() { document.removeEventListener("keydown", this.keyDownFunction, false); }
    keyDownFunction(event) {
        if (event.key === "Escape") {
            if (this.closeMe != undefined) {
                event.preventDefault();
                if (this.state.confirmBeforeEsacpe === true) {
                    this.setState({ showConfirmClose: true });
                }
                else {
                    this.closeMe();
                }
            }
        }
        if (event.key === "F4") {
            if (this.save != undefined) {
                event.preventDefault();
                this.save();
            }
        }
        if (event.key === "F2") {
            if (this.onAdd != undefined) {
                event.preventDefault();
                this.onAdd();
            }
        }
    }
    renewGridConfig() {
        this.setState({ data: this.state.data });
    }
    getGridConfig() {
        return this.getDefaultConfig();

        var config = localStorage.getItem(this.state.configName);
        if (this.isNull(config)) config = this.getDefaultConfig();
        else config = JSON.parse(config);
        return config;
    }
    renderAgGrid(params) {
        var defaultColDef = this.AG_GRID_DEFAULT_COLUMN({
            flex: this.isNull(params.flex) ? 1 : params.flex
        });
        if (params.rowSelection === 'singleRow') {
            defaultColDef.headerCheckboxSelection = false;
            defaultColDef.checkboxSelection = false;
        }
        return <div className="ag-theme-quartz" style={{ "height": "calc( 100vh - 190px)" }}>
            <AgGridReact
                ref={r => this.gridRef = r}
                overlayNoRowsTemplate="نتیجه برای نمایش وجود ندارد"
                rowData={this.isNull(params.records) ? this.state.data.records : params.records}
                columnDefs={params.columnDefs}
                defaultColDef={defaultColDef}
                onSelectionChanged={e => this.setAgGridSelectedRow(e.api.getSelectedRows())}
                headerHeight={35}
                rowHeight={35} 
                enableRtl={true} 
                pagination={this.isNull(params.pagination) ? true : params.pagination}
                rowSelection={this.isNull(params.rowSelection) ? 'multiple' : params.rowSelection}
                paginationPageSize={30}
                paginationPageSizeSelector={[10, 20, 30, 50, 100, 200, 500]}
                localeText={this.AG_GRID_LOCALE_EN()}
            />
        </div>
    }
    setAgGridSelectedRow(e) {
        var t = [];
        e.forEach(ee => t.push(ee.id));
        this.state.selectedIds = t;
    }
    setSelectedRow(isNew, id) {
        if (this.isNull(this.state.selectedIds)) this.state.selectedIds = [];

        if (isNew) {
            if (!this.state.selectedIds.includes(id)) this.state.selectedIds.push(id);
        }
        else {
            var t = [];
            this.state.selectedIds.forEach(f => { if (f != id) t.push(f) });
            this.state.selectedIds = t;
        }
    }
    getGridColumnValues(fieldName) {
        var records = [];
        this.gridRef.api.forEachNodeAfterFilterAndSort(printNode => {
            var v = printNode.data[fieldName];
            if (!this.isEmpty(v)) {
                records.push(v);
            }
        });
        return records;
    }
    onPrint(reportTitle = '') {
        this.export('print', reportTitle);
    }
    onPdf(reportTitle = '') {
        this.export('pdf', reportTitle);
    }
    onExcel(reportTitle = '') {
        this.export('excel', reportTitle);
    }
    export(format = 'pdf', reportTitle = '') {
        var records = [];
        var columns = [];
        this.gridRef.api.columnModel.ariaOrderColumns.forEach(column => {
            if (column.colId != 0) {
                var t = column.userProvidedColDef.cellDataType;
                if (this.isBlank(t)) t = "text";
                columns.push({ field: column.colId, caption: column.userProvidedColDef.headerName, type: t });
            }
        });
        this.gridRef.api.forEachNodeAfterFilterAndSort(printNode => {
            var dataRow = {};
            columns.forEach(c => {
                if (!this.isBlank(c.field)) {
                    var v = printNode.data[c.field];
                    if (this.isNull(v)) {
                        if (c.type == "text") v = "";
                        if (c.type == "number") v = 0;
                        if (c.type == "boolean") v = false;
                    }
                    dataRow[c.field] = {
                        value: v,
                        type: c.type
                    };
                }
            });
            records.push(dataRow);
        });

        this.setState({ loading: true });

        this.httpPost("api/v1/common/exports", {
            records,
            columns,
            reportTitle,
            format
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    if (format == 'pdf') this.downloadPDF(data.bs64);
                    if (format == 'excel') this.downloadExcel(data.bs64);
                    if (format == 'print') this.state.printBs64 = data.bs64;
                    this.setState({
                        loading: false
                    })
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    onRemove(e) {
        if (this.isEmpty(this.state.selectedIds)) {
            this.showErorrMessage("لطفا آیتم های مورد نظر جهت حذف را انتخاب نمایید");
            return;
        }
        this.setState({ showConfirmRemove: true });
    }
    getToolBar(isPopup = true, params = {
        add: true,
        print: true,
        pdf: true,
        excell: true,
        remove: true,
        otherFilters: null,
        config: false
    }) {
        if (this.isNull(params)) return null;

        return (
            <div style={{ "padding": "2px 5px" }}>
                {params.add &&
                    <a className="btn btn-primary" onClick={e => this.onAdd()}><span style={{ "margin-left": "5px" }} className="fa fa-plus"></span> جدید</a>
                }
                {params.otherFilters}
                {
                    params.print &&
                    <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onPrint('فهرست ' + this.state.moduleName)} title="چاپ">
                        <em style={{ "fontSize": "1.8rem" }} className="icon ni ni-printer" ></em>
                    </a>
                }
                {
                    params.pdf &&
                    <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onPdf('فهرست ' + this.state.moduleName)} title="پی دی اف">
                        <em style={{ "fontSize": "1.8rem" }} className="icon ni ni-file-pdf"></em>
                    </a>
                }
                {
                    params.excell &&
                    <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onExcel('فهرست ' + this.state.moduleName)} title="اکسل">
                        <em style={{ "fontSize": "1.8rem" }} className="icon ni ni-file-xls"></em>
                    </a>
                }
                {
                    params.remove &&
                    <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onRemove()} title="حذف">
                        <em style={{ "fontSize": "1.8rem" }} className="icon ni ni-trash"></em>
                    </a>
                }
                {params.config && <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onGridConfig()} title="تنظیمات نمایش">
                    <em style={{ "fontSize": "1.8rem" }} className="icon ni ni-setting"></em>
                </a>}
                {isPopup && <a className="hand" onClick={e => this.closeMe()} style={{ "position": "absolute", "left": "-3px", "top": "-27px" }}><i className="fa fa-close"></i></a>}
            </div>
        )
    }
    displayMinuteAsTimeFormat(e) {
        if (e < 60) return "00:" + this.FixedPointNumber(e % 60, 0).toString().padStart(2, '0');

        var h = parseInt(e / 60).toString().padStart(2, '0');
        var m = this.FixedPointNumber(e % 60, 0).toString().padStart(2, '0');
        return h + ":" + m;
    }
    getDefaultGuid() {
        return '00000000-0000-0000-0000-000000000000';
    }
    defaultGuid() {
        return '00000000-0000-0000-0000-000000000000';
    }
    playNotificationSound() {
        try {
            var audio = new Audio("/assets/notification.wav");
            audio.play();
        } catch { }
    }
    FixedPointNumber(e, f = 2) {
        if (e == null || e == undefined || e == "") return 0;
        return parseFloat(e.toFixed(f))
    }
    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    topicContentType(e) {
        if (e == 1) return "درس";
        if (e == 3) return "تمرین";
        return "";
    }
    getCurrentFormId2() {
        var id = this.state.id;
        if (this.isBlank(id)) return 0;

        if (id == 1) {
            var urlParts = window.location.href.split("/");
            if (window.location.href.endsWith("/"))
                id = urlParts[urlParts.length - 3];
            else
                id = urlParts[urlParts.length - 2];
        }
        if (id.toString().includes("-")) return id;
        else return parseInt(id);
    }
    getCurrentFormId3() {
        var id = this.state.id;
        if (this.isBlank(id)) return 0;

        if (id == 1) {
            var urlParts = window.location.href.split("/");
            if (window.location.href.endsWith("/"))
                id = urlParts[urlParts.length - 4];
            else
                id = urlParts[urlParts.length - 3];
        }
        if (id.toString().includes("-")) return id;
        else return parseInt(id);
    }
    getCurrentFormId() {
        var id = this.state.id;
        if (this.isBlank(id)) return 0;

        if (id == 1) {
            var urlParts = window.location.href.split("/");
            if (window.location.href.endsWith("/"))
                id = urlParts[urlParts.length - 2];
            else
                id = urlParts[urlParts.length - 1];
        }
        if (id.toString().includes("-")) return id;
        else return parseInt(id);
    }
    isEmpty(i) {
        if (i == undefined || i == null || i == "") return true;
        if (i.length <= 0) return true;
        return false;
    }
    isBlank(i) {
        if (i == undefined || i == null || i == "") return true;
        return false;
    }
    isNull(i) {
        if (i == undefined || i == null) return true;
        return false;
    }
    getGlobalContainer() {
        return [
            !this.isBlank(this.state.printBs64) && <div className="modal fade in show" tabindex="-1" aria-hidden="true" style={{ "zIndex": "1050" }}>
                <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => { this.setState({ printBs64: '' }); }}></div>
                <div className="modal-dialog" role="document" style={{ "width": "96%" }}>
                    <div className="modal-content">
                        <div className="modal-body modal-body-lg text-center" style={{ "padding": "3px" }}>
                            <div className="nk-modal">
                                <div className="nk-modal-text" style={{ "height": "80vh", "margin-bottom": "0" }}>
                                    <embed src={"data:application/pdf;base64," + this.state.printBs64} type="application/pdf" width="100%" height="100%" />
                                </div>
                                <div className="nk-modal-action" style={{ "margin-top": "0" }}>
                                    <a className="btn btn-sm btn-mw btn-primary hand" data-bs-dismiss="modal" onClick={e => { this.setState({ printBs64: '' }); }}>برگشت</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            ,
            this.state.showConfirmRemove && <div className="modal fade show" tabindex="-1" id="modalConfirmRemove" aria-hidden="true" style={{ "z-index": "99999999" }} >
                <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => { this.setState({ showConfirmRemove: false }); }}></div>
                <div className="modal-dialog" role="document" style={{ "max-width": "610px" }}>
                    <div className="modal-content">
                        <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                                <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                                <h4 className="nk-modal-title">هشدار حذف اطلاعات</h4>
                                <div className="nk-modal-text">
                                    <p className="lead">آیا از حذف آیتم انتخابی مطمئن هستید؟</p>
                                    <p className="text-soft">توجه داشته باشید که در صورت حذف اطلاعات دیگر امکان بازیابی اطلاعات وجود ندارد</p>
                                </div>
                                <div className="nk-modal-action mt-5">
                                    <a className="btn btn-lg btn-mw btn-danger hand" data-bs-dismiss="modal" onClick={e => { this.remove(); }} style={{ "margin-left": "25px" }}>بله - حذف شود</a>
                                    <a className="btn btn-lg btn-mw btn-light hand" data-bs-dismiss="modal" onClick={e => { this.setState({ showConfirmRemove: false }); }}>خیر - برگشت</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            ,
            this.state.showConfirmClose === true && <div className="modal fade show" tabindex="-1" id="modalConfirmRemove" aria-hidden="true" style={{ "z-index": "99999999" }} >
                <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => { this.setState({ showConfirmClose: false }); }}></div>
                <div className="modal-dialog" role="document" style={{ "max-width": "610px" }}>
                    <div className="modal-content">
                        <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                                <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                                <h4 className="nk-modal-title">هشدار حذف اطلاعات</h4>
                                <div className="nk-modal-text">
                                    <p className="lead">آیا این فرم بسته شود؟</p>
                                </div>
                                <div className="nk-modal-action mt-5">
                                    <a className="btn btn-lg btn-mw btn-danger hand" data-bs-dismiss="modal" onClick={e => { this.closeMe(); }} style={{ "margin-left": "25px" }}>بله</a>
                                    <a className="btn btn-lg btn-mw btn-light hand" data-bs-dismiss="modal" onClick={e => { this.setState({ showConfirmClose: false }); }}>خیر</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ];
    }
    showErorrMessage(msg) {
        toast.error(msg, {
            position: "top-center",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
        });
    }
    showSuccessMessage(msg) {
        toast.success(msg, {
            position: "top-center",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
        });
    }
    httpPost(url, body = {}, lockScreen = true) {
        if (lockScreen) this.setState({ lockScreen: 1 });
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (lockScreen) this.setState({ lockScreen: 0 });
                    if (data != null && data != undefined) {
                        if (data.global != null && data.global != undefined) {
                            if (data.global.company != null && data.global.company != undefined) {
                                window.companyId = data.global.company.id;
                                window.organizationId = data.global.company.id;
                            }
                            //if (data.global.user != null && data.global.user != undefined) {
                            //    try {
                            //        document.getElementById('navmenu_mgr').innerText = data.global.adminTicketCount + data.global.userDraftsCount +
                            //            data.global.userDocumentCount + data.global.projectToApproveCount

                            //            + data.global.newsToPublishCount + data.global.commentsToApproveCount
                            //            + data.global.qasToApproveCount + data.global.certificateToApproveCount
                            //            + data.global.excerciesToApproveCount
                            //            + data.global.userCourseToPublishCount + data.global.userBookToPublishCount
                            //            + data.global.userQuestionToPublishCount + data.global.userExamToPublishCount;

                            //        if (document.getElementById('navmenu_mgr').innerText == '0') {
                            //            document.getElementById('navmenu_mgr').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr').style.display = "unset";
                            //        }

                            //        document.getElementById('navmenu_mgr_lms').innerText = data.global.newsToPublishCount + data.global.commentsToApproveCount
                            //            + data.global.qasToApproveCount + data.global.certificateToApproveCount
                            //            + data.global.excerciesToApproveCount
                            //            + data.global.userCourseToPublishCount + data.global.userBookToPublishCount
                            //            + data.global.userQuestionToPublishCount + data.global.userExamToPublishCount;

                            //        if (document.getElementById('navmenu_mgr_lms').innerText == '0') {
                            //            document.getElementById('navmenu_mgr_lms').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_lms').style.display = "unset";
                            //        }

                            //        document.getElementById('navmenu_mgr_lms_course_user').innerText = data.global.userCourseToPublishCount;
                            //        document.getElementById('navmenu_mgr_lms_book_user').innerText = data.global.userBookToPublishCount;
                            //        document.getElementById('navmenu_mgr_lms_question_user').innerText = data.global.userQuestionToPublishCount;
                            //        document.getElementById('navmenu_mgr_lms_exame_user').innerText = data.global.userExamToPublishCount;

                            //        if (document.getElementById('navmenu_mgr_lms_course_user').innerText == '0') {
                            //            document.getElementById('navmenu_mgr_lms_course_user').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_lms_course_user').style.display = "unset";
                            //        }
                            //        if (document.getElementById('navmenu_mgr_lms_book_user').innerText == '0') {
                            //            document.getElementById('navmenu_mgr_lms_book_user').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_lms_book_user').style.display = "unset";
                            //        }
                            //        if (document.getElementById('navmenu_mgr_lms_question_user').innerText == '0') {
                            //            document.getElementById('navmenu_mgr_lms_question_user').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_lms_question_user').style.display = "unset";
                            //        }
                            //        if (document.getElementById('navmenu_mgr_lms_exame_user').innerText == '0') {
                            //            document.getElementById('navmenu_mgr_lms_exame_user').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_lms_exame_user').style.display = "unset";
                            //        }

                            //        document.getElementById('navmenu_mgr_lms_news').innerText = data.global.newsToPublishCount;
                            //        document.getElementById('navmenu_mgr_lms_comments').innerText = data.global.commentsToApproveCount;
                            //        document.getElementById('navmenu_mgr_lms_qas').innerText = data.global.qasToApproveCount;
                            //        document.getElementById('navmenu_mgr_lms_exercise').innerText = data.global.excerciesToApproveCount;
                            //        document.getElementById('navmenu_mgr_lms_certificates').innerText = data.global.certificateToApproveCount;

                            //        if (data.global.newsToPublishCount == 0) {
                            //            document.getElementById('navmenu_mgr_lms_news').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_lms_news').style.display = "unset";
                            //        }
                            //        if (data.global.commentsToApproveCount == 0) {
                            //            document.getElementById('navmenu_mgr_lms_comments').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_lms_comments').style.display = "unset";
                            //        }
                            //        if (data.global.qasToApproveCount == 0) {
                            //            document.getElementById('navmenu_mgr_lms_qas').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_lms_qas').style.display = "unset";
                            //        }
                            //        if (data.global.certificateToApproveCount == 0) {
                            //            document.getElementById('navmenu_mgr_lms_certificates').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_lms_certificates').style.display = "unset";
                            //        }
                            //        if (data.global.excerciesToApproveCount == 0) {
                            //            document.getElementById('navmenu_mgr_lms_exercise').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_lms_exercise').style.display = "unset";
                            //        }

                            //        document.getElementById('navmenu_mgr_tickets').innerText = data.global.adminTicketCount;
                            //        document.getElementById('navmenu_mgr_userdrafts').innerText = data.global.userDraftsCount;
                            //        document.getElementById('navmenu_mgr_userdocuments').innerText = data.global.userDocumentCount;
                            //        document.getElementById('navmenu_mgr_outsourcing').innerText = data.global.projectToApproveCount;
                            //        document.getElementById('navmenu_mgr_outsourcing_projects').innerText = data.global.projectToApproveCount;

                            //        if (data.global.adminTicketCount == 0) {
                            //            document.getElementById('navmenu_mgr_tickets').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_tickets').style.display = "unset";
                            //        }

                            //        if (data.global.userDraftsCount == 0) {
                            //            document.getElementById('navmenu_mgr_userdrafts').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_userdrafts').style.display = "unset";
                            //        }
                            //        if (data.global.userDocumentCount == 0) {
                            //            document.getElementById('navmenu_mgr_userdocuments').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_userdocuments').style.display = "unset";
                            //        }
                            //        if (data.global.projectToApproveCount == 0) {
                            //            document.getElementById('navmenu_mgr_outsourcing_projects').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_outsourcing_projects').style.display = "unset";
                            //        }

                            //        if (document.getElementById('navmenu_mgr_outsourcing').innerText == '0') {
                            //            document.getElementById('navmenu_mgr_outsourcing').style.display = "none";
                            //        } else {
                            //            document.getElementById('navmenu_mgr_outsourcing').style.display = "unset";
                            //        }

                            //    } catch (err) { }
                            //}
                        }
                    }
                    resolve(data);
                })
                .catch(err => {
                    this.setState({ lockScreen: 0 });
                    this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
                    resolve(null);
                });
        });
    }
    renderLoading() {
        return <div className="lockBox">
            <div className="preview-item">
                <button className="btn btn-primary" type="button" disabled>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span>لطفا کمی صبر نمایید ...</span>
                </button>
            </div>
        </div>
    }
    uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }
    lockScreen() {
        return <div className="lockBox">
            <div className="preview-item">
                <button className="btn btn-primary" type="button" disabled>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span>لطفا کمی صبر نمایید ...</span>
                </button>
            </div>
        </div>
    }
    money(value) {
        var number = typeof value === "number" ? value.toString() : value;
        var separator = ',';
        if (number === null || number === undefined)
            return "";
        var s = number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + separator);
        return s;
    }
    logOut() {
        this.httpPost("api/v1/logout")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.location.href = "/login"
                }
                else {
                    this.showErorrMessage(data.message);
                }
            });
    }
    changeAnnual(id) {
        this.httpPost("api/v1/common/switchannual", { id })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.location.href = window.location.href;
                }
                else {
                    this.showErorrMessage(data.message);
                }
            });
    }
    changeCompany(id) {
        this.httpPost("api/v1/common/switchcompany", { id })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.location.href = window.location.href;
                }
                else {
                    this.showErorrMessage(data.message);
                }
            });
    }
    renderNoCompanyRegister() {
        return <div className="card-inner-group">
            <div className="example-alert">
                <div className="alert alert-pro alert-warning">
                    <div className="alert-text">
                        <h6>توجه</h6>
                        <p>شما هنوز هیچ کسب و کاری برای خود تعریف نکرده اید. جهت دسترسی به این بخش بایستی ابتدا یک کسب و کار تعریف نمایید</p>
                        <p><NavLink className="btn btn-primary" to="/company/new/">افزودن کسب و کار جدید</NavLink></p>
                    </div>
                </div>
            </div>
        </div>
    }
    renderNoAnnual() {
        return <div className="card-inner-group">
            <div className="example-alert">
                <div className="alert alert-pro alert-warning">
                    <div className="alert-text">
                        <h6>توجه</h6>
                        <p>شما هنوز هیچ سال مالی برای کسب و کار خود تعریف نکرده اید. جهت دسترسی به این بخش بایستی ابتدا یک سال مالی تعریف نمایید</p>
                        <p><NavLink className="btn btn-primary" to="/annual/new/">افزودن سال مالی جدید</NavLink></p>
                    </div>
                </div>
            </div>
        </div>
    }
    confirmRemove(e) {
        if (this.isNull(e) && this.isEmpty(this.state.selectedIds)) {
            this.showErorrMessage("لطفا آیتم های مورد نظر جهت حذف را انتخاب نمایید");
            return;
        }
        this.state.id_to_remove = e;
        this.setState({ showConfirmRemove: true });
    }
    remove() {
        var id = this.state.id_to_remove;
        if (this.isNull(id) && !this.isNull(this.state.selectedIds)) id = this.state.selectedIds;

        var companyId = null;
        if (!this.isNull(this.state.data.global.company)) {
            companyId = this.state.data.global.company.id;
        }

        this.httpPost("api/v1/" + this.state.controllerName + "/remove", {
            id,
            companyId: companyId,
            organizationId: companyId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
                    this.state.showConfirmRemove = false;
                    this.state.id_to_remove = null;
                    this.state.selectedIds = [];
                    this.state.selectedReportId = this.getDefaultGuid();
                    this.refreshData();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({ showConfirmRemove: false });
                }
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    async refreshData(e, action = "list", outputFormat="json",pageReset = false) {
        if (!this.isNull(e)) e.preventDefault();
        //this.setState({ loading: true });

        if (pageReset) this.state.page = 1;
		
        this.httpPost("api/v1/" + this.state.controllerName + "/" + action, {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase,
            sort: this.state.sort ? this.state.sort : '',
            paging: this.state.paging ? this.state.paging : true,
            counting: this.state.counting ? this.state.counting : true,
            filters: this.state.filters,
            outputFormat
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 0) {
                    if (data.message) {
                        this.showErorrMessage(data.message);
                    }

                    this.setState({
                        selectedIds: [],
                        loading: false
                    });
                }
                else {
                    if (outputFormat == 'excel') this.downloadExcel(data.bs64);
                    if (outputFormat == 'pdf') this.downloadPDF(data.bs64);
                    if (outputFormat == "json") {
                        this.state.data = data;
                    }
                    this.setState({
                        loading: false
                    });
                }
            })
    }
    exportFromUrl(format = 'pdf', url = '') {
        this.httpPost(url, {
            format
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    if (format == 'pdf') this.downloadPDF(data.bs64);
                    if (format == 'excel') this.downloadExcel(data.bs64);
                    if (format == 'print') this.state.printBs64 = data.bs64;
                }
                else {
                }
            });
    }
    async getPdfs() {
        this.httpPost("api/v1/" + this.state.controllerName + "/prints", {
            phrase: this.state.phrase,
            filters: this.state.filters,
            isPdf: 1
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.downloadPDF(data.bs64);
                }
                else {
                }
            })
    }
    async getPdf(id = null, bodyOtherFields = {}) {
        if (id == null) id = this.getCurrentFormId();
        bodyOtherFields.id = id;

        bodyOtherFields.printFormat = this.state.printFormat;
        if (this.isNull(bodyOtherFields.printFormat)) bodyOtherFields.printFormat = '';

        this.httpPost("api/v1/" + this.state.controllerName + "/print", bodyOtherFields)
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.downloadPDF(data.bs64);
                }
                else {
                }
            })
    }
    handlePageChange(page) {
        this.state.page = page;
        this.refreshData(null,"list","json",false);
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }
    handlePerRowsChange(newPerPage) {
        this.state.page = 1;
        this.state.per_page = newPerPage;
        this.refreshData();
    }
    createPaging() {
        let total_page = Math.ceil(this.state.data.recordsCount / this.state.per_page);
        let pages = [];
        let start_page = Math.max(1, this.state.page - 2);
        let end_page = Math.min(total_page, this.state.page + 3);

        if (end_page > total_page)
            end_page = total_page;

        if (start_page == end_page && start_page == 1) {

        }
        else {
            if (this.state.page > 1)
                pages.push(<li className="page-item"><a className="page-link hand" onClick={e => this.handlePageChange(this.state.page - 1)}>قبلی</a></li>);

            for (let i = start_page; i <= end_page; i++) {
                pages.push(<li className="page-item"><a className={"page-link hand " + (this.state.page === i ? "active" : "")} onClick={e => this.handlePageChange(i)}>{i}</a></li>);
            }

            if (this.state.page < total_page)
                pages.push(<li className="page-item"><a className="page-link hand" onClick={e => this.handlePageChange(this.state.page + 1)}>بعدی</a></li>);
        }
        if (this.isEmpty(pages)) return null;

        return <div className="card-inner">
            <div className="nk-block-between-md g-3">
                <div className="g">
                    <ul className="pagination justify-content-center justify-content-md-start">{pages}</ul>
                </div>
                <div className="g">
                    <div className="pagination-goto d-flex justify-content-center justify-content-md-start gx-3">
                        <div>تعداد در هر صفحه</div>
                        <div>
                            <select className="form-select js-select2" data-search="on" data-dropdown="xs center" defaultValue={this.state.per_page} onChange={e => this.handlePerRowsChange(parseInt(e.target.value))}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="40">40</option>
                                <option value="60">60</option>
                                <option value="80">80</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    genRowNumber(index) {
        index++;
        return ((this.state.page - 1) * this.state.per_page) + index;
    }
    downloadPDF(pdf) {
        const linkSource = `data:application/pdf;base64,${pdf}`;
        const downloadLink = document.createElement("a");
        const fileName = "report.pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }
    downloadExcel(pdf) {
        const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${pdf}`;
        const downloadLink = document.createElement("a");
        const fileName = "report.xlsx";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }
    getSystemModuleName() {
        if (this.state.systemModuleId == 1) return "مودیان";
        if (this.state.systemModuleId == 2) return "شرکتها";
        if (this.state.systemModuleId == 3) return "حقوق و دستمزد";
        if (this.state.systemModuleId == 4) return "فروش";
        if (this.state.systemModuleId == 5) return "انبار";
        if (this.state.systemModuleId == 6) return "گزارش ساز پیشرفته";
        if (this.state.systemModuleId == 7) return "دریافت و پرداخت";
        if (this.state.systemModuleId == 8) return "مدیریت اسناد";
        if (this.state.systemModuleId == 9) return "سفارشات";
        if (this.state.systemModuleId == 24) return "مدیریت پروژه ها";
        if (this.state.systemModuleId == 25) return "مدیریت ارتباط با مشتریان";
        if (this.state.systemModuleId == 26) return "مدیریت قراردادها";
        if (this.state.systemModuleId == 27) return "دبیرخانه";
        if (this.state.systemModuleId == 28) return "جلسات";
        if (this.state.systemModuleId == 29) return "مدیریت ساختمان";
        if (this.state.systemModuleId == 30) return "مدیریت اموال";
        if (this.state.systemModuleId == 31) return "کمپین تبلیغاتی";

        return "مربوطه"
    }
    renderSystemModuleExpired() {
        return <div className="row g-4">
            <div className="example-alert text-center">
                <div className="alert alert-pro alert-warning">
                    <div className="alert-text">
                        <h6>هشدار</h6>
                        جهت دسترسی به این بخش بایستی ماژول {this.getSystemModuleName()} را خریداری یا تمدید نمایید
                        <NavLink to="/renewal/" className="btn btn-primary">تمدید ماژول ها</NavLink>
                    </div>
                </div>
            </div>
        </div>
    }
    renderSystemModuleNotFound() {
        return <div className="row g-4">
            <div className="example-alert text-center">
                <div className="alert alert-pro alert-danger">
                    <div className="alert-text">
                        <h6>خطا</h6>
                        <p>محدودیت استفاده رایگان شما به پایان رسیده است،جهت مشاهده و دسترسی به این بخش شما بایستی ماژول {this.getSystemModuleName()} را خریداری نمایید</p>
                        <NavLink to="/buy/modules/" className="btn btn-primary">خرید و سفارش</NavLink>
                    </div>
                </div>
            </div>
        </div>
    }
    renderSystemModuleAnnualNotDefined() {
        return <div className="row g-4">
            <div className="example-alert text-center">
                <div className="alert alert-pro alert-danger">
                    <div className="alert-text">
                        <h6>خطا</h6>
                        <p>جهت دسترسی به این بخش بایستی ابتدا یک سال مال تعریف نمایید</p>
                        <NavLink to="/annuals/" className="btn btn-primary">ایجاد سال مالی</NavLink>
                    </div>
                </div>
            </div>
        </div>
    }
    renderPermissionDenied() {
        return <div className="row g-4">
            <div className="example-alert text-center">
                <div className="alert alert-pro alert-danger">
                    <div className="alert-text">
                        <h6>خطا</h6>
                        <p>دسترسی به این بخش از برنامه توسط مالک کسب و کار به شما اعطا نشده است. لطفا از مدیر کسب و کار خود بخواهید تا دسترسی شما به این بخش از سامانه را فعال نمایند.</p>
                    </div>
                </div>
            </div>
        </div>
    }
    renderSystemModuleModuleAccessMessage(code,message) {
        if (code == -2) return this.renderSystemModuleNotFound();
        if (code == -3) return this.renderSystemModuleExpired();
        if (code == -5) return this.renderSystemModuleAnnualNotDefined();

        return null;
    }
    convertMomentToDb(e) {
        if (this.isNull(e)) return "";
        if (!e._isAMomentObject) return e;
        return e.format('jYYYY-jMM-jDD');
    }
    getFormatedDateForDatePicker(dt, defaultIsNull = null) {
        if (dt === undefined) if (defaultIsNull === null) return null; else return momentJalaali(defaultIsNull);
        if (dt === null) if (defaultIsNull === null) return null; else return momentJalaali(defaultIsNull);
        if (dt === "") if (defaultIsNull === null) return null; else return momentJalaali(defaultIsNull);
        if ((typeof dt) === "object") {
            return dt;
        }
        if ((typeof dt) === "string") {
            dt = this.g2j(dt, 3);
            return momentJalaali(dt, 'jYYYY-jMM-jDD');
        }
        else {
            return momentJalaali(dt, 'jYYYY-jMM-jDD');
        }
    }
    //format
    //0 => ۲۰ آذر ۱۳۹۸
    //1 => آذر
    //2 => چهارشنبه، ۷ اسفند، ۱۳۹۸
    //3=>1398/12/25
    //4 => 1398
    //5 => 25
    //6 => چهارشنبه، ۷ اسفند، ۱۳۹۸ ۱۲:۲۰:۳۰
    //7 => 1398/12/25 12:12:12
    g2j(pDate, format = 0) {
        try {
            if (pDate === null || pDate === undefined) return "";
            //وقتی سمت سرور رندر میکنیم این مقدار به صورت یک آبجکت تاریخ هست که بایستی تبدیل کنیم به رشته تاریخی
            if (typeof (pDate) === "string") {
                pDate = new Date(pDate)
            }

            var gy = '';
            var gm = '';
            var gd = '';

            gy = parseInt(pDate.getFullYear());
            gm = parseInt(pDate.getMonth() + 1);
            gd = parseInt(pDate.getDate());

            if (gy === '') return '';
            var g_d_m, jy, jm, jd, gy2, days;
            g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
            if (gy > 1600) {
                jy = 979;
                gy -= 1600;
            } else {
                jy = 0;
                gy -= 621;
            }
            gy2 = (gm > 2) ? (gy + 1) : gy;
            days = (365 * gy) + (parseInt((gy2 + 3) / 4)) - (parseInt((gy2 + 99) / 100)) + (parseInt((gy2 + 399) / 400)) - 80 + gd + g_d_m[gm - 1];
            jy += 33 * (parseInt(days / 12053));
            days %= 12053;
            jy += 4 * (parseInt(days / 1461));
            days %= 1461;
            if (days > 365) {
                jy += parseInt((days - 1) / 365);
                days = (days - 1) % 365;
            }
            jm = (days < 186) ? 1 + parseInt(days / 31) : 7 + parseInt((days - 186) / 30);
            jd = 1 + ((days < 186) ? (days % 31) : ((days - 186) % 30));
            if (format === 0) {
                if (jm === 1)
                    return jd + " فروردین " + jy;
                if (jm === 2)
                    return jd + " اردیبهشت " + jy;
                if (jm === 3)
                    return jd + " خرداد " + jy;
                if (jm === 4)
                    return jd + " تیر " + jy;
                if (jm === 5)
                    return jd + " مرداد " + jy;
                if (jm === 6)
                    return jd + " شهریور " + jy;
                if (jm === 7)
                    return jd + " مهر " + jy;
                if (jm === 8)
                    return jd + " آبان " + jy;
                if (jm === 9)
                    return jd + " آذر " + jy;
                if (jm === 10)
                    return jd + " دی " + jy;
                if (jm === 11)
                    return jd + " بهمن " + jy;
                if (jm === 12)
                    return jd + " اسفند " + jy;
            }
            if (format === 1) {
                if (jm === 1)
                    return "فروردین";
                if (jm === 2)
                    return "اردیبهشت";
                if (jm === 3)
                    return "خرداد";
                if (jm === 4)
                    return "تیر";
                if (jm === 5)
                    return "مرداد";
                if (jm === 6)
                    return "شهریور";
                if (jm === 7)
                    return "مهر";
                if (jm === 8)
                    return "آبان";
                if (jm === 9)
                    return "آذر";
                if (jm === 10)
                    return "دی";
                if (jm === 11)
                    return "بهمن";
                if (jm === 12)
                    return "اسفند";
            }
            if (format === 2) {
                let dayOfWeekNum = pDate.getDay();
                let dayName = '';
                if (dayOfWeekNum === 0) dayName = 'یکشنبه';
                if (dayOfWeekNum === 1) dayName = 'دوشنبه';
                if (dayOfWeekNum === 2) dayName = 'سه شنبه';
                if (dayOfWeekNum === 3) dayName = 'چهارشنبه';
                if (dayOfWeekNum === 4) dayName = 'پنجشنبه';
                if (dayOfWeekNum === 5) dayName = 'جمعه';
                if (dayOfWeekNum === 6) dayName = 'شنبه';
                if (jm === 1)
                    return dayName + '، ' + jd + " فروردین، " + jy;
                if (jm === 2)
                    return dayName + '، ' + jd + " اردیبهشت، " + jy;
                if (jm === 3)
                    return dayName + '، ' + jd + " خرداد، " + jy;
                if (jm === 4)
                    return dayName + '، ' + jd + " تیر، " + jy;
                if (jm === 5)
                    return dayName + '، ' + jd + " مرداد، " + jy;
                if (jm === 6)
                    return dayName + '، ' + jd + " شهریور، " + jy;
                if (jm === 7)
                    return dayName + '، ' + jd + " مهر، " + jy;
                if (jm === 8)
                    return dayName + '، ' + jd + " آبان، " + jy;
                if (jm === 9)
                    return dayName + '، ' + jd + " آذر، " + jy;
                if (jm === 10)
                    return dayName + '، ' + jd + " دی، " + jy;
                if (jm === 11)
                    return dayName + '، ' + jd + " بهمن، " + jy;
                if (jm === 12)
                    return dayName + '، ' + jd + " اسفند، " + jy;
            }
            if (format === 3) {
                if (jd < 10) jd = "0" + jd;
                if (jm < 10) jm = "0" + jm;
                return jy + "/" + jm + "/" + jd;
            }
            if (format === 4) {
                return jy;
            }
            if (format === 5) {
                return jd;
            }
            if (format === 6) {
                let dayOfWeekNum = pDate.getDay();
                let dayName = '';
                if (dayOfWeekNum === 0) dayName = 'یکشنبه';
                if (dayOfWeekNum === 1) dayName = 'دوشنبه';
                if (dayOfWeekNum === 2) dayName = 'سه شنبه';
                if (dayOfWeekNum === 3) dayName = 'چهارشنبه';
                if (dayOfWeekNum === 4) dayName = 'پنجشنبه';
                if (dayOfWeekNum === 5) dayName = 'جمعه';
                if (dayOfWeekNum === 6) dayName = 'شنبه';
                var time = pDate.getHours() + ":" + pDate.getMinutes() + ":" + pDate.getSeconds();

                if (jm === 1)
                    return dayName + '، ' + jd + " فروردین، " + jy + " " + time;
                if (jm === 2)
                    return dayName + '، ' + jd + " اردیبهشت، " + jy + " " + time;
                if (jm === 3)
                    return dayName + '، ' + jd + " خرداد، " + jy + " " + time;
                if (jm === 4)
                    return dayName + '، ' + jd + " تیر، " + jy + " " + time;
                if (jm === 5)
                    return dayName + '، ' + jd + " مرداد، " + jy + " " + time;
                if (jm === 6)
                    return dayName + '، ' + jd + " شهریور، " + jy + " " + time;
                if (jm === 7)
                    return dayName + '، ' + jd + " مهر، " + jy + " " + time;
                if (jm === 8)
                    return dayName + '، ' + jd + " آبان، " + jy + " " + time;
                if (jm === 9)
                    return dayName + '، ' + jd + " آذر، " + jy + " " + time;
                if (jm === 10)
                    return dayName + '، ' + jd + " دی، " + jy + " " + time;
                if (jm === 11)
                    return dayName + '، ' + jd + " بهمن، " + jy + " " + time;
                if (jm === 12)
                    return dayName + '، ' + jd + " اسفند، " + jy + " " + time;
            }
            if (format === 7) {
                var timeHour = pDate.getHours();
                var timeMinutes = pDate.getMinutes();
                var timeSeccond = pDate.getSeconds();

                if (timeHour < 10) timeHour = '0' + timeHour;
                if (timeMinutes < 10) timeMinutes = '0' + timeMinutes;
                if (timeSeccond < 10) timeSeccond = '0' + timeSeccond;

                var time = timeHour + ":" + timeMinutes + ":" + timeSeccond;

                if (jd < 10) jd = "0" + jd;
                if (jm < 10) jm = "0" + jm;

                return time + " " + jy + "/" + jm + "/" + jd;
            }
            return jy + "-" + jm + "-" + jd;
        }
        catch (err) { return "" }
    }
    copyToClipboard(e) {
        navigator.clipboard.writeText(e);
        this.showSuccessMessage("کپی شد");
    }
    AG_GRID_DEFAULT_COLUMN(params) {
        return {
            filter: true,
            floatingFilter: true,
            headerCheckboxSelection: this.isFirstColumn,
            checkboxSelection: this.isFirstColumn,
            cellDataType: 'text',
            flex: (this.isNull(params.flex) ? 1 : params.flex)
        }
    }
    AG_GRID_LOCALE_EN() {
        return {
            // Set Filter
            selectAll: '(انتخاب همه)',
            selectAllSearchResults: '(Select All Search Results)',
            addCurrentSelectionToFilter: 'Add current selection to filter',
            searchOoo: 'جستجو...',
            blanks: '(Blanks)',
            noMatches: 'No matches',

            // Number Filter & Text Filter
            filterOoo: 'فیلتر...',
            equals: 'برابر',
            notEqual: 'نامساوی',
            blank: 'خالی',
            notBlank: 'خالی نباشد',
            empty: 'Choose one',

            // Number Filter
            lessThan: 'کمتر از',
            greaterThan: 'بزرگتر از',
            lessThanOrEqual: 'کوچکتر یا مساوی با',
            greaterThanOrEqual: 'بزرگتر یا مساوی با',
            inRange: 'مابین',
            inRangeStart: 'از',
            inRangeEnd: 'تا',

            // Text Filter
            contains: 'شامل',
            notContains: 'شامل نباشد',
            startsWith: 'شروع شده با',
            endsWith: 'تمام شده با',

            // Date Filter
            dateFormatOoo: 'yyyy-mm-dd',
            before: 'قبل',
            after: 'بعد',

            // Filter Conditions
            andCondition: 'و',
            orCondition: 'یا',

            // Filter Buttons
            applyFilter: 'اعمال',
            resetFilter: 'ریست',
            clearFilter: 'خالی کردن',
            cancelFilter: 'انصراف',

            // Filter Titles
            textFilter: 'فیلتر متن',
            numberFilter: 'فیلتر عدد',
            dateFilter: 'فیلتر تاریخ',
            setFilter: 'Set Filter',

            // Group Column Filter
            groupFilterSelect: 'انتخاب فیلد:',

            // Advanced Filter
            advancedFilterContains: 'شامل',
            advancedFilterNotContains: 'does not contain',
            advancedFilterTextEquals: 'مساوی',
            advancedFilterTextNotEqual: 'نامساوری',
            advancedFilterStartsWith: 'شروع شده با',
            advancedFilterEndsWith: 'پایان یافته با',
            advancedFilterBlank: 'خالی است',
            advancedFilterNotBlank: 'خالی نیست',
            advancedFilterEquals: '=',
            advancedFilterNotEqual: '!=',
            advancedFilterGreaterThan: '>',
            advancedFilterGreaterThanOrEqual: '>=',
            advancedFilterLessThan: '<',
            advancedFilterLessThanOrEqual: '<=',
            advancedFilterTrue: 'is true',
            advancedFilterFalse: 'is false',
            advancedFilterAnd: 'و',
            advancedFilterOr: 'یا',
            advancedFilterApply: 'اعمال',
            advancedFilterBuilder: 'Builder',
            advancedFilterValidationMissingColumn: 'Column is missing',
            advancedFilterValidationMissingOption: 'Option is missing',
            advancedFilterValidationMissingValue: 'Value is missing',
            advancedFilterValidationInvalidColumn: 'Column not found',
            advancedFilterValidationInvalidOption: 'Option not found',
            advancedFilterValidationMissingQuote: 'Value is missing an end quote',
            advancedFilterValidationNotANumber: 'Value is not a number',
            advancedFilterValidationInvalidDate: 'Value is not a valid date',
            advancedFilterValidationMissingCondition: 'Condition is missing',
            advancedFilterValidationJoinOperatorMismatch: 'Join operators within a condition must be the same',
            advancedFilterValidationInvalidJoinOperator: 'Join operator not found',
            advancedFilterValidationMissingEndBracket: 'Missing end bracket',
            advancedFilterValidationExtraEndBracket: 'Too many end brackets',
            advancedFilterValidationMessage: 'Expression has an error. ${variable} - ${variable}.',
            advancedFilterValidationMessageAtEnd: 'Expression has an error. ${variable} at end of expression.',
            advancedFilterBuilderTitle: 'Advanced Filter',
            advancedFilterBuilderApply: 'Apply',
            advancedFilterBuilderCancel: 'Cancel',
            advancedFilterBuilderAddButtonTooltip: 'Add Filter or Group',
            advancedFilterBuilderRemoveButtonTooltip: 'Remove',
            advancedFilterBuilderMoveUpButtonTooltip: 'Move Up',
            advancedFilterBuilderMoveDownButtonTooltip: 'Move Down',
            advancedFilterBuilderAddJoin: 'Add Group',
            advancedFilterBuilderAddCondition: 'Add Filter',
            advancedFilterBuilderSelectColumn: 'Select a column',
            advancedFilterBuilderSelectOption: 'Select an option',
            advancedFilterBuilderEnterValue: 'Enter a value...',
            advancedFilterBuilderValidationAlreadyApplied: 'Current filter already applied.',
            advancedFilterBuilderValidationIncomplete: 'Not all conditions are complete.',
            advancedFilterBuilderValidationSelectColumn: 'Must select a column.',
            advancedFilterBuilderValidationSelectOption: 'Must select an option.',
            advancedFilterBuilderValidationEnterValue: 'Must enter a value.',

            // Side Bar
            columns: 'ستونها',
            filters: 'فیلترها',

            // columns tool panel
            pivotMode: 'Pivot Mode',
            groups: 'Row Groups',
            rowGroupColumnsEmptyMessage: 'Drag here to set row groups',
            values: 'Values',
            valueColumnsEmptyMessage: 'Drag here to aggregate',
            pivots: 'Column Labels',
            pivotColumnsEmptyMessage: 'Drag here to set column labels',

            // Header of the Default Group Column
            group: 'گروه',

            // Row Drag
            rowDragRow: 'ردیف',
            rowDragRows: 'ردیفها',

            // Other
            loadingOoo: 'دریافت اطلاعات...',
            loadingError: 'ERR',
            noRowsToShow: 'No Rows To Show',
            enabled: 'Enabled',

            // Menu
            pinColumn: 'Pin Column',
            pinLeft: 'Pin Left',
            pinRight: 'Pin Right',
            noPin: 'No Pin',
            valueAggregation: 'Value Aggregation',
            noAggregation: 'None',
            autosizeThiscolumn: 'Autosize This Column',
            autosizeAllColumns: 'Autosize All Columns',
            groupBy: 'Group by',
            ungroupBy: 'Un-Group by',
            ungroupAll: 'Un-Group All',
            addToValues: 'Add ${variable} to values',
            removeFromValues: 'Remove ${variable} from values',
            addToLabels: 'Add ${variable} to labels',
            removeFromLabels: 'Remove ${variable} from labels',
            resetColumns: 'Reset Columns',
            expandAll: 'Expand All Row Groups',
            collapseAll: 'Close All Row Groups',
            copy: 'Copy',
            ctrlC: 'Ctrl+C',
            ctrlX: 'Ctrl+X',
            copyWithHeaders: 'Copy With Headers',
            copyWithGroupHeaders: 'Copy with Group Headers',
            cut: 'Cut',
            paste: 'Paste',
            ctrlV: 'Ctrl+V',
            export: 'Export',
            csvExport: 'CSV Export',
            excelExport: 'Excel Export',
            columnFilter: 'Column Filter',
            columnChooser: 'Choose Columns',
            sortAscending: 'Sort Ascending',
            sortDescending: 'Sort Descending',
            sortUnSort: 'Clear Sort',

            // Enterprise Menu Aggregation and Status Bar
            sum: 'مجموع',
            first: 'اولین',
            last: 'آخرین',
            min: 'کمترین',
            max: 'بیشترین',
            none: 'None',
            count: 'تعداد',
            avg: 'میانگین',
            filteredRows: 'فیلتر شده',
            selectedRows: 'انتخاب شده',
            totalRows: 'کل ردیفها',
            totalAndFilteredRows: 'ردیفها',
            more: 'بیشتر',
            to: 'تا',
            of: 'از',
            page: 'صفحه',
            pageLastRowUnknown: '?',
            nextPage: 'صفحه بعدی',
            lastPage: 'آخرین صفحه',
            firstPage: 'اولین صفحه',
            previousPage: 'صفحه قبلی',
            pageSizeSelectorLabel: 'تعداد در صفحه:',
            footerTotal: 'مجموع',

            // Pivoting
            pivotColumnGroupTotals: 'مجموع',

            // Enterprise Menu (Charts)
            pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
            pivotChart: 'Pivot Chart',
            chartRange: 'Chart Range',

            columnChart: 'ستون',
            groupedColumn: 'Grouped',
            stackedColumn: 'Stacked',
            normalizedColumn: '100% Stacked',

            barChart: 'Bar',
            groupedBar: 'Grouped',
            stackedBar: 'Stacked',
            normalizedBar: '100% Stacked',

            pieChart: 'Pie',
            pie: 'Pie',
            donut: 'Donut',

            line: 'Line',

            xyChart: 'X Y (Scatter)',
            scatter: 'Scatter',
            bubble: 'Bubble',

            areaChart: 'Area',
            area: 'Area',
            stackedArea: 'Stacked',
            normalizedArea: '100% Stacked',

            histogramChart: 'Histogram',
            histogramFrequency: "Frequency",

            polarChart: 'Polar',
            radarLine: 'Radar Line',
            radarArea: 'Radar Area',
            nightingale: 'Nightingale',
            radialColumn: 'Radial Column',
            radialBar: 'Radial Bar',

            statisticalChart: 'Statistical',
            boxPlot: 'Box Plot',
            rangeBar: 'Range Bar',
            rangeArea: 'Range Area',

            hierarchicalChart: 'Hierarchical',
            treemap: 'Treemap',
            sunburst: 'Sunburst',

            specializedChart: 'Specialized',
            waterfall: 'Waterfall',
            heatmap: 'Heatmap',

            combinationChart: 'Combination',
            columnLineCombo: 'Column & Line',
            AreaColumnCombo: 'Area & Column',

            // Charts
            pivotChartTitle: 'Pivot Chart',
            rangeChartTitle: 'Range Chart',
            settings: 'Chart',
            data: 'Data',
            format: 'Format',
            categories: 'Categories',
            defaultCategory: '(None)',
            series: 'Series',
            switchCategorySeries: 'Switch Category / Series',
            categoryValues: 'Category Values',
            seriesLabels: 'Series Labels',
            aggregate: 'Aggregate',
            xyValues: 'X Y Values',
            paired: 'Paired Mode',
            axis: 'Axis',
            xAxis: 'Horizontal Axis',
            yAxis: 'Vertical Axis',
            polarAxis: 'Polar Axis',
            radiusAxis: 'Radius Axis',
            navigator: 'Navigator',
            zoom: 'Zoom',
            animation: 'Animation',
            crosshair: 'Crosshair',
            color: 'Color',
            thickness: 'Thickness',
            preferredLength: 'Preferred Length',
            xType: 'X Type',
            axisType: 'Axis Type',
            automatic: 'Automatic',
            category: 'Category',
            number: 'Number',
            time: 'Time',
            timeFormat: 'Time Format',
            autoRotate: 'Auto Rotate',
            labelRotation: 'Rotation',
            circle: 'Circle',
            polygon: 'Polygon',
            orientation: 'Orientation',
            fixed: 'Fixed',
            parallel: 'Parallel',
            perpendicular: 'Perpendicular',
            radiusAxisPosition: 'Position',
            ticks: 'Ticks',
            gridLines: 'Grid Lines',
            width: 'Width',
            height: 'Height',
            length: 'Length',
            padding: 'Padding',
            spacing: 'Spacing',
            chart: 'Chart',
            title: 'Title',
            titlePlaceholder: 'Chart title - double click to edit',
            background: 'Background',
            font: 'Font',
            top: 'Top',
            right: 'Right',
            bottom: 'Bottom',
            left: 'Left',
            labels: 'Labels',
            calloutLabels: 'Callout Labels',
            sectorLabels: 'Sector Labels',
            positionRatio: 'Position Ratio',
            size: 'Size',
            shape: 'Shape',
            minSize: 'Minimum Size',
            maxSize: 'Maximum Size',
            legend: 'Legend',
            position: 'Position',
            markerSize: 'Marker Size',
            markerStroke: 'Marker Stroke',
            markerPadding: 'Marker Padding',
            itemSpacing: 'Item Spacing',
            itemPaddingX: 'Item Padding X',
            itemPaddingY: 'Item Padding Y',
            layoutHorizontalSpacing: 'Horizontal Spacing',
            layoutVerticalSpacing: 'Vertical Spacing',
            strokeWidth: 'Stroke Width',
            offset: 'Offset',
            offsets: 'Offsets',
            tooltips: 'Tooltips',
            callout: 'Callout',
            markers: 'Markers',
            shadow: 'Shadow',
            blur: 'Blur',
            xOffset: 'X Offset',
            yOffset: 'Y Offset',
            lineWidth: 'Line Width',
            lineDash: 'Line Dash',
            lineDashOffset: 'Dash Offset',
            scrollingZoom: 'Scrolling',
            scrollingStep: 'Scrolling Step',
            selectingZoom: 'Selecting',
            durationMillis: 'Duration (ms)',
            crosshairLabel: 'Label',
            crosshairSnap: 'Snap to Node',
            normal: 'Normal',
            bold: 'Bold',
            italic: 'Italic',
            boldItalic: 'Bold Italic',
            predefined: 'Predefined',
            fillOpacity: 'Fill Opacity',
            strokeColor: 'Line Color',
            strokeOpacity: 'Line Opacity',
            miniChart: 'Mini-Chart',
            histogramBinCount: 'Bin count',
            connectorLine: 'Connector Line',
            seriesItems: 'Series Items',
            seriesItemType: 'Item Type',
            seriesItemPositive: 'Positive',
            seriesItemNegative: 'Negative',
            seriesItemLabels: 'Item Labels',
            columnGroup: 'Column',
            barGroup: 'Bar',
            pieGroup: 'Pie',
            lineGroup: 'Line',
            scatterGroup: 'X Y (Scatter)',
            areaGroup: 'Area',
            polarGroup: 'Polar',
            statisticalGroup: 'Statistical',
            hierarchicalGroup: 'Hierarchical',
            specializedGroup: 'Specialized',
            combinationGroup: 'Combination',
            groupedColumnTooltip: 'Grouped',
            stackedColumnTooltip: 'Stacked',
            normalizedColumnTooltip: '100% Stacked',
            groupedBarTooltip: 'Grouped',
            stackedBarTooltip: 'Stacked',
            normalizedBarTooltip: '100% Stacked',
            pieTooltip: 'Pie',
            donutTooltip: 'Donut',
            lineTooltip: 'Line',
            groupedAreaTooltip: 'Area',
            stackedAreaTooltip: 'Stacked',
            normalizedAreaTooltip: '100% Stacked',
            scatterTooltip: 'Scatter',
            bubbleTooltip: 'Bubble',
            histogramTooltip: 'Histogram',
            radialColumnTooltip: 'Radial Column',
            radialBarTooltip: 'Radial Bar',
            radarLineTooltip: 'Radar Line',
            radarAreaTooltip: 'Radar Area',
            nightingaleTooltip: 'Nightingale',
            rangeBarTooltip: 'Range Bar',
            rangeAreaTooltip: 'Range Area',
            boxPlotTooltip: 'Box Plot',
            treemapTooltip: 'Treemap',
            sunburstTooltip: 'Sunburst',
            waterfallTooltip: 'Waterfall',
            heatmapTooltip: 'Heatmap',
            columnLineComboTooltip: 'Column & Line',
            areaColumnComboTooltip: 'Area & Column',
            customComboTooltip: 'Custom Combination',
            innerRadius: 'Inner Radius',
            startAngle: 'Start Angle',
            endAngle: 'End Angle',
            reverseDirection: 'Reverse Direction',
            groupPadding: 'Group Padding',
            seriesPadding: 'Series Padding',
            tile: 'Tile',
            whisker: 'Whisker',
            cap: 'Cap',
            capLengthRatio: 'Length Ratio',
            labelPlacement: 'Placement',
            inside: 'Inside',
            outside: 'Outside',
            noDataToChart: 'No data available to be charted.',
            pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
            chartSettingsToolbarTooltip: 'Menu',
            chartLinkToolbarTooltip: 'Linked to Grid',
            chartUnlinkToolbarTooltip: 'Unlinked from Grid',
            chartDownloadToolbarTooltip: 'Download Chart',
            chartEdit: 'Edit Chart',
            chartAdvancedSettings: 'Advanced Settings',
            chartLink: 'Link to Grid',
            chartUnlink: 'Unlink from Grid',
            chartDownload: 'Download Chart',
            seriesChartType: 'Series Chart Type',
            seriesType: 'Series Type',
            secondaryAxis: 'Secondary Axis',
            seriesAdd: 'Add a series',
            categoryAdd: 'Add a category',
            advancedSettings: 'Advanced Settings',
            direction: 'Direction',
            horizontal: 'Horizontal',
            vertical: 'Vertical',
            seriesGroupType: 'Group Type',
            groupedSeriesGroupType: 'Grouped',
            stackedSeriesGroupType: 'Stacked',
            normalizedSeriesGroupType: '100% Stacked',

            // ARIA
            ariaAdvancedFilterBuilderItem: '${variable}. Level ${variable}. Press ENTER to edit.',
            ariaAdvancedFilterBuilderItemValidation: '${variable}. Level ${variable}. ${variable} Press ENTER to edit.',
            ariaAdvancedFilterBuilderList: 'Advanced Filter Builder List',
            ariaAdvancedFilterBuilderFilterItem: 'Filter Condition',
            ariaAdvancedFilterBuilderGroupItem: 'Filter Group',
            ariaAdvancedFilterBuilderColumn: 'Column',
            ariaAdvancedFilterBuilderOption: 'Option',
            ariaAdvancedFilterBuilderValueP: 'Value',
            ariaAdvancedFilterBuilderJoinOperator: 'Join Operator',
            ariaAdvancedFilterInput: 'Advanced Filter Input',
            ariaChecked: 'checked',
            ariaColumn: 'Column',
            ariaColumnGroup: 'Column Group',
            ariaColumnFiltered: 'Column Filtered',
            ariaColumnSelectAll: 'Toggle Select All Columns',
            ariaDateFilterInput: 'Date Filter Input',
            ariaDefaultListName: 'List',
            ariaFilterColumnsInput: 'Filter Columns Input',
            ariaFilterFromValue: 'Filter from value',
            ariaFilterInput: 'Filter Input',
            ariaFilterList: 'Filter List',
            ariaFilterToValue: 'Filter to value',
            ariaFilterValue: 'Filter Value',
            ariaFilterMenuOpen: 'Open Filter Menu',
            ariaFilteringOperator: 'Filtering Operator',
            ariaHidden: 'hidden',
            ariaIndeterminate: 'indeterminate',
            ariaInputEditor: 'Input Editor',
            ariaMenuColumn: 'Press ALT DOWN to open column menu',
            ariaFilterColumn: 'Press CTRL ENTER to open filter',
            ariaRowDeselect: 'Press SPACE to deselect this row',
            ariaRowSelectAll: 'Press Space to toggle all rows selection',
            ariaRowToggleSelection: 'Press Space to toggle row selection',
            ariaRowSelect: 'Press SPACE to select this row',
            ariaRowSelectionDisabled: 'Row Selection is disabled for this row',
            ariaSearch: 'Search',
            ariaSortableColumn: 'Press ENTER to sort',
            ariaToggleVisibility: 'Press SPACE to toggle visibility',
            ariaToggleCellValue: 'Press SPACE to toggle cell value',
            ariaUnchecked: 'unchecked',
            ariaVisible: 'visible',
            ariaSearchFilterValues: 'Search filter values',
            ariaPageSizeSelectorLabel: 'Page Size',
            ariaChartMenuClose: 'Close Chart Edit Menu',
            ariaSkeletonCellLoadingFailed: 'Row failed to load',
            ariaSkeletonCellLoading: 'Row data is loading',

            // ARIA Labels for Drop Zones
            ariaRowGroupDropZonePanelLabel: 'Row Groups',
            ariaValuesDropZonePanelLabel: 'Values',
            ariaPivotDropZonePanelLabel: 'Column Labels',
            ariaDropZoneColumnComponentDescription: 'Press DELETE to remove',
            ariaDropZoneColumnValueItemDescription: 'Press ENTER to change the aggregation type',
            ariaDropZoneColumnGroupItemDescription: 'Press ENTER to sort',
            // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeparator}{column name}
            ariaDropZoneColumnComponentAggFuncSeparator: ' of ',
            ariaDropZoneColumnComponentSortAscending: 'ascending',
            ariaDropZoneColumnComponentSortDescending: 'descending',

            // ARIA Labels for Dialogs
            ariaLabelColumnMenu: 'Column Menu',
            ariaLabelColumnFilter: 'Column Filter',
            ariaLabelCellEditor: 'Cell Editor',
            ariaLabelDialog: 'Dialog',
            ariaLabelSelectField: 'Select Field',
            ariaLabelRichSelectField: 'Rich Select Field',
            ariaLabelTooltip: 'Tooltip',
            ariaLabelContextMenu: 'Context Menu',
            ariaLabelSubMenu: 'SubMenu',
            ariaLabelAggregationFunction: 'Aggregation Function',
            ariaLabelAdvancedFilterAutocomplete: 'Advanced Filter Autocomplete',
            ariaLabelAdvancedFilterBuilderAddField: 'Advanced Filter Builder Add Field',
            ariaLabelAdvancedFilterBuilderColumnSelectField: 'Advanced Filter Builder Column Select Field',
            ariaLabelAdvancedFilterBuilderOptionSelectField: 'Advanced Filter Builder Option Select Field',
            ariaLabelAdvancedFilterBuilderJoinSelectField: 'Advanced Filter Builder Join Operator Select Field',

            // ARIA Labels for the Side Bar
            ariaColumnPanelList: 'Column List',
            ariaFilterPanelList: 'Filter List',

            // Number Format (Status Bar, Pagination Panel)
            thousandSeparator: '،',
            decimalSeparator: '.',

            // Data types
            true: 'True',
            false: 'False',
            invalidDate: 'Invalid Date',
            invalidNumber: 'Invalid Number',
            january: 'January',
            february: 'February',
            march: 'March',
            april: 'April',
            may: 'May',
            june: 'June',
            july: 'July',
            august: 'August',
            september: 'September',
            october: 'October',
            november: 'November',
            december: 'December',

            // Time formats
            timeFormatSlashesDDMMYYYY: 'DD/MM/YYYY',
            timeFormatSlashesMMDDYYYY: 'MM/DD/YYYY',
            timeFormatSlashesDDMMYY: 'DD/MM/YY',
            timeFormatSlashesMMDDYY: 'MM/DD/YY',
            timeFormatDotsDDMYY: 'DD.M.YY',
            timeFormatDotsMDDYY: 'M.DD.YY',
            timeFormatDashesYYYYMMDD: 'YYYY-MM-DD',
            timeFormatSpacesDDMMMMYYYY: 'DD MMMM YYYY',
            timeFormatHHMMSS: 'HH:MM:SS',
            timeFormatHHMMSSAmPm: 'HH:MM:SS AM/PM',
        }
    }
    isFirstColumn(params) {
        var displayedColumns = params.api.getAllDisplayedColumns();
        var thisIsFirstColumn = displayedColumns[0] === params.column;
        return thisIsFirstColumn;
    }

    getSVGIcon(item, cls = '') {
        var icon = null;
        if (item == "flowchart") icon = <path d="M183.8 197.1L256 293.4C263.3 289.9 271.4 288 280 288H360C390.9 288 416 313.1 416 344V424C416 454.9 390.9 480 360 480H280C249.1 480 224 454.9 224 424V344C224 333.3 226.1 323.4 232.2 314.9L159.1 218.6C152.7 222.1 144.6 224 136 224H56C25.07 224 0 198.9 0 168V88C0 57.07 25.07 32 56 32H136C166.9 32 192 57.07 192 88V112H384V88C384 57.07 409.1 32 440 32H520C550.9 32 576 57.07 576 88V168C576 198.9 550.9 224 520 224H440C409.1 224 384 198.9 384 168V144H192V168C192 178.7 189 188.6 183.8 197.1V197.1zM136 64H56C42.75 64 32 74.75 32 88V168C32 181.3 42.75 192 56 192H136C149.3 192 160 181.3 160 168V88C160 74.75 149.3 64 136 64zM440 192H520C533.3 192 544 181.3 544 168V88C544 74.75 533.3 64 520 64H440C426.7 64 416 74.75 416 88V168C416 181.3 426.7 192 440 192zM360 320H280C266.7 320 256 330.7 256 344V424C256 437.3 266.7 448 280 448H360C373.3 448 384 437.3 384 424V344C384 330.7 373.3 320 360 320z" />
        if (item == "journal") icon = <path d="M544 320h-63.1L480 144C480 82.25 429.8 32 368 32h-288C35.88 32 0 67.88 0 112V192c0 17.62 14.38 32 32 32h96l.001 160c0 51.13 40.25 92.63 90.62 95.5l248 .5C527 480 576 431 576 370.6V352C576 334.4 561.6 320 544 320zM128 192H32V112C32 85.5 53.5 64 80 64S128 85.5 128 112L128 192zM288 384c0 35.25-28.75 64-64 64s-64-28.75-64-64V256h48C216.8 256 224 248.8 224 240S216.8 224 208 224H160L160 112C160 94 153.1 77.38 144 64h224c38.64 0 70.95 27.52 78.38 64H400C391.2 128 384 135.2 384 144S391.2 160 400 160h48L448 224h-48C391.2 224 384 231.2 384 240S391.2 256 400 256h48L448 320h-128c-17.62 0-31.1 14.38-31.1 32L288 384zM544 370.6C544 413.3 509.3 448 466.6 448H295C310.4 431 320 408.6 320 384v-32h48v16c0 8.844 7.158 16 16 16S400 376.8 400 368V352H544V370.6z" />
        if (item == "tree") icon = <path d="M0 72C0 58.75 10.75 48 24 48H72C85.25 48 96 58.75 96 72V120C96 133.3 85.25 144 72 144H64V240H128V232C128 218.7 138.7 208 152 208H200C213.3 208 224 218.7 224 232V280C224 293.3 213.3 304 200 304H152C138.7 304 128 293.3 128 280V272H64V384C64 392.8 71.16 400 80 400H128V392C128 378.7 138.7 368 152 368H200C213.3 368 224 378.7 224 392V440C224 453.3 213.3 464 200 464H152C138.7 464 128 453.3 128 440V432H80C53.49 432 32 410.5 32 384V144H24C10.75 144 0 133.3 0 120V72zM64 112V80H32V112H64zM192 432V400H160V432H192zM160 240V272H192V240H160zM160 96C160 87.16 167.2 80 176 80H496C504.8 80 512 87.16 512 96C512 104.8 504.8 112 496 112H176C167.2 112 160 104.8 160 96zM288 256C288 247.2 295.2 240 304 240H496C504.8 240 512 247.2 512 256C512 264.8 504.8 272 496 272H304C295.2 272 288 264.8 288 256zM288 416C288 407.2 295.2 400 304 400H496C504.8 400 512 407.2 512 416C512 424.8 504.8 432 496 432H304C295.2 432 288 424.8 288 416z" />
        if (item == "calendar") icon = <path d="M384 64h-32V16C352 7.164 344.8 0 336 0S320 7.164 320 16L320 64h-192L128 16C128 7.164 120.8 0 112 0S96 7.164 96 16V64H64C28.65 64 0 92.65 0 128v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V128C448 92.65 419.3 64 384 64zM416 448c0 17.67-14.33 32-32 32H64c-17.67 0-32-14.33-32-32V192h384V448zM416 160H32V128c0-17.67 14.33-32 32-32h320c17.67 0 32 14.33 32 32V160zM112 304h224C344.8 304 352 296.8 352 288s-7.156-16-16-16h-224C103.2 272 96 279.2 96 288S103.2 304 112 304zM112 400h128c8.844 0 16-7.156 16-16s-7.156-16-16-16h-128C103.2 368 96 375.2 96 384S103.2 400 112 400z" fill="currentColor" />
        if (item == "calendar-star") icon = <path d="M384 64h-32V16C352 7.164 344.8 0 336 0S320 7.164 320 16L320 64h-192L128 16C128 7.164 120.8 0 112 0S96 7.164 96 16V64H64C28.65 64 0 92.65 0 128v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V128C448 92.65 419.3 64 384 64zM416 448c0 17.67-14.33 32-32 32H64c-17.67 0-32-14.33-32-32V192h384V448zM416 160H32V128c0-17.67 14.33-32 32-32h320c17.67 0 32 14.33 32 32V160zM149.9 368.1l-7.938 46.22c-1.89 10.53 2.328 21.06 11.03 27.41c8.688 6.375 20.05 7.25 29.58 2.156l41.41-21.91l41.5 21.94c4.156 2.188 8.656 3.281 13.12 3.281c5.781 0 11.55-1.844 16.47-5.438c8.672-6.312 12.89-16.81 11.03-27.34l-7.953-46.31l33.66-32.81c7.609-7.469 10.31-18.44 7.047-28.59c-3.297-10.16-11.89-17.5-22.58-19.16l-46.44-6.781l-20.78-41.95c-4.734-9.609-14.31-15.59-25.02-15.62c-10.67 0-20.34 5.953-25.17 15.61L178.1 281.6L131.8 288.4C121.1 290 112.4 297.4 109.1 307.7c-3.25 10.19-.4687 21.16 7.203 28.56L149.9 368.1zM199.4 310.9L224 261.1l24.64 49.78l55.05 8.031l-39.88 38.88l9.406 54.88l-49.23-26l-49.08 25.97l9.406-54.84L144.4 318.9L199.4 310.9z" fill="currentColor" />
        if (item == "camcorder") icon = <path d="M304 223.1h-224c-8.844 0-16 7.156-16 16c0 8.842 7.156 15.1 16 15.1h224c8.844 0 16-7.158 16-15.1C320 231.2 312.8 223.1 304 223.1zM558.8 163.7c-10.59-5.484-23.35-4.74-33.13 2.12l-102.8 72.02c-7.25 5.062-9 15.05-3.938 22.28c5.062 7.25 15.02 8.984 22.28 3.938l102.8-71.97v255.9l-102.8-71.97c-7.266-5.047-17.22-3.312-22.28 3.938c-5.062 7.234-3.312 17.22 3.938 22.28l102.8 72C531.1 478.1 537.5 480 543.1 480c5.047 0 10.12-1.203 14.78-3.625c10.64-5.531 17.23-16.41 17.23-28.39V192C576 180.1 569.4 169.2 558.8 163.7zM320 159.1H96V111.1C96 85.53 117.5 63.1 144 63.1h160c8.844 0 16-7.156 16-16C320 39.16 312.8 32 304 32h-160C99.88 32 64 67.89 64 111.1l.0003 48c-35.35 0-64 28.66-64 64l-.0001 191.1c0 35.34 28.65 63.1 64 63.1l256-.0016c35.35 0 64-28.66 64-63.1V223.1C384 188.7 355.3 159.1 320 159.1zM352 415.1c0 17.64-14.36 31.1-32 31.1H64c-17.64 0-32-14.35-32-31.1V223.1c0-17.64 14.36-31.1 32-31.1h256c17.64 0 32 14.36 32 31.1V415.1z" fill="currentColor" />
        if (item == "event") icon = <path d="M384 64h-32V16C352 7.164 344.8 0 336 0S320 7.164 320 16V64H128V16C128 7.164 120.8 0 112 0S96 7.164 96 16V64H64C28.65 64 0 92.65 0 128v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V128C448 92.65 419.3 64 384 64zM416 448c0 17.67-14.33 32-32 32H64c-17.67 0-32-14.33-32-32V192h384V448zM416 160H32V128c0-17.67 14.33-32 32-32h320c17.67 0 32 14.33 32 32V160zM96 384h96c17.67 0 32-14.33 32-32V256c0-17.67-14.33-32-32-32H96C78.33 224 64 238.3 64 256v96C64 369.7 78.33 384 96 384zM96 256h96v96H96V256z" fill="currentColor" />
        if (item == "trash-undo") icon = <path d="M219.9 189.3C225.8 195.9 225.3 205.1 218.7 211.9L169.7 256H240C284.2 256 320 291.8 320 336V376C320 384.8 312.8 392 304 392C295.2 392 288 384.8 288 376V336C288 309.5 266.5 288 240 288H169.7L218.7 332.1C225.3 338 225.8 348.1 219.9 354.7C213.1 361.3 203.9 361.8 197.3 355.9L117.3 283.9C113.9 280.9 112 276.5 112 271.1C112 267.5 113.9 263.1 117.3 260.1L197.3 188.1C203.9 182.2 213.1 182.7 219.9 189.3V189.3zM432 64C440.8 64 448 71.16 448 80C448 88.84 440.8 96 432 96H413.7L388.2 452.6C385.9 486.1 357.1 512 324.4 512H123.6C90.01 512 62.15 486.1 59.75 452.6L34.29 96H16C7.164 96 0 88.84 0 80C0 71.16 7.164 64 16 64H111.1L137 22.56C145.8 8.526 161.2 0 177.7 0H270.3C286.8 0 302.2 8.526 310.1 22.56L336.9 64H432zM177.7 32C172.2 32 167.1 34.84 164.2 39.52L148.9 64H299.1L283.8 39.52C280.9 34.84 275.8 32 270.3 32H177.7zM381.6 96H66.37L91.67 450.3C92.87 467 106.8 480 123.6 480H324.4C341.2 480 355.1 467 356.3 450.3L381.6 96z" />
        if (item == "trash") icon = <path d="M148.7 212.7C154.9 206.4 165.1 206.4 171.3 212.7L224 265.4L276.7 212.7C282.9 206.4 293.1 206.4 299.3 212.7C305.6 218.9 305.6 229.1 299.3 235.3L246.6 288L299.3 340.7C305.6 346.9 305.6 357.1 299.3 363.3C293.1 369.6 282.9 369.6 276.7 363.3L224 310.6L171.3 363.3C165.1 369.6 154.9 369.6 148.7 363.3C142.4 357.1 142.4 346.9 148.7 340.7L201.4 288L148.7 235.3C142.4 229.1 142.4 218.9 148.7 212.7zM310.1 22.56L336.9 64H432C440.8 64 448 71.16 448 80C448 88.84 440.8 96 432 96H416V432C416 476.2 380.2 512 336 512H112C67.82 512 32 476.2 32 432V96H16C7.164 96 0 88.84 0 80C0 71.16 7.164 64 16 64H111.1L137 22.56C145.8 8.526 161.2 0 177.7 0H270.3C286.8 0 302.2 8.526 310.1 22.56V22.56zM148.9 64H299.1L283.8 39.52C280.9 34.84 275.8 32 270.3 32H177.7C172.2 32 167.1 34.84 164.2 39.52L148.9 64zM64 432C64 458.5 85.49 480 112 480H336C362.5 480 384 458.5 384 432V96H64V432z" />
        if (item == "file-pdf") icon = <path d="M384 448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448H32C32 465.7 46.33 480 64 480H320C337.7 480 352 465.7 352 448H384zM240 192C213.5 192 192 170.5 192 144V32H64C46.33 32 32 46.33 32 64V224H0V64C0 28.65 28.65 0 64 0H220.1C232.8 0 245.1 5.057 254.1 14.06L369.9 129.9C378.9 138.9 384 151.2 384 163.9V224H352V192H240zM347.3 152.6L231.4 36.69C229.4 34.62 226.8 33.18 224 32.48V144C224 152.8 231.2 160 240 160H351.5C350.8 157.2 349.4 154.6 347.3 152.6zM88 256C118.9 256 144 281.1 144 312C144 342.9 118.9 368 88 368H80V400C80 408.8 72.84 416 64 416C55.16 416 48 408.8 48 400V272C48 263.2 55.16 256 64 256H88zM112 312C112 298.7 101.3 288 88 288H80V336H88C101.3 336 112 325.3 112 312zM160 272C160 263.2 167.2 256 176 256H200C226.5 256 248 277.5 248 304V368C248 394.5 226.5 416 200 416H176C167.2 416 160 408.8 160 400V272zM192 384H200C208.8 384 216 376.8 216 368V304C216 295.2 208.8 288 200 288H192V384zM336 256C344.8 256 352 263.2 352 272C352 280.8 344.8 288 336 288H304V320H336C344.8 320 352 327.2 352 336C352 344.8 344.8 352 336 352H304V400C304 408.8 296.8 416 288 416C279.2 416 272 408.8 272 400V272C272 263.2 279.2 256 288 256H336z" />
        if (item == "file-word") icon = <path d="M177.1 250.1l-44 110L111.7 252.9c-1.719-8.656-10.11-14.33-18.83-12.55C84.2 242 78.58 250.5 80.31 259.1l32 160c1.391 6.938 7.172 12.14 14.22 12.8c7.25 .6562 13.7-3.422 16.33-10L192 299.1l49.14 122.9C243.6 428.1 249.5 432 256 432c.4844 0 .9687-.0156 1.469-.0625c7.047-.6562 12.83-5.859 14.22-12.8l32-160c1.734-8.672-3.891-17.09-12.55-18.83c-8.781-1.812-17.11 3.875-18.83 12.55l-21.45 107.2l-44-110C201.1 237.9 182 237.9 177.1 250.1zM365.3 125.3l-106.5-106.5C246.7 6.742 230.5 0 213.5 0H64C28.65 0 0 28.65 0 64l.0065 384c0 35.35 28.65 64 64 64H320c35.35 0 64-28.65 64-64V170.5C384 153.5 377.3 137.3 365.3 125.3zM224 34.08c4.477 1.566 8.666 3.846 12.12 7.299l106.5 106.5C346.1 151.3 348.4 155.5 349.9 160H240C231.2 160 224 152.8 224 144V34.08zM352 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h128v112C192 170.5 213.5 192 240 192H352V448z" />
        if (item == "student2") icon = <path d="M359.2 312.8l-103.2 103.2l-103.2-103.2c-69.93 22.31-120.8 87.19-120.8 164.5C32 496.5 47.53 512 66.67 512h378.7C464.5 512 480 496.5 480 477.3C480 400 429.1 335.1 359.2 312.8zM445.3 479.1H66.66c-1.469 0-2.664-1.197-2.664-2.668c0-55.04 31.85-104 80.95-127.1L233.4 438.6c6.248 6.248 14.44 9.373 22.63 9.373c8.189 0 16.38-3.125 22.63-9.373l88.43-88.43c49.09 23.08 80.95 72.09 80.95 127.1C448 478.8 446.8 479.1 445.3 479.1zM44.41 79.59L64 84.11v89.31L32.83 266.9C31.19 271.8 32.02 277.2 35.02 281.4c3.016 4.172 7.844 6.641 12.98 6.641H112c5.141 0 9.969-2.469 12.98-6.641c2.1-4.172 3.828-9.547 2.187-14.42L96 173.4V91.49L128 98.88l.0016 29.12c0 5.734 3.076 11.05 8.061 13.89l64.37 36.78c17.14 9.797 36.34 14.69 55.56 14.69c19.22 0 38.42-4.891 55.56-14.69l64.37-36.78c4.984-2.844 8.063-8.156 8.063-13.89L384 98.88l83.59-19.29c7.266-1.672 12.39-8.141 12.39-15.59s-5.126-13.92-12.39-15.59l-207.1-48c-2.344-.5313-4.844-.5313-7.187 0L44.41 48.4C37.14 50.07 31.99 56.56 31.99 64.01S37.14 77.92 44.41 79.59zM352 118.7l-56.31 32.17c-24.47 13.97-54.91 13.97-79.37 0L160 118.7V106.3l92.41 21.32c1.172 .2656 2.33 .4063 3.533 .4063s2.483-.1406 3.654-.4063l92.41-21.32V118.7zM256 32.41l136.8 31.58l-136.8 31.58L119.2 63.99L256 32.41zM80 226.6l9.797 29.41H70.2L80 226.6zM368 159.1c-8.844 0-16 7.157-16 16c0 52.94-43.06 96-95.1 96S160 228.9 160 175.1c0-8.844-7.155-16-15.1-16S128 167.2 128 175.1c0 70.58 57.42 128 127.1 128s127.1-57.42 127.1-128C384 167.2 376.8 159.1 368 159.1z" />
        if (item == "student") icon = <path d="M617.8 136.7l-286.3-102.7C324 31.33 315.9 31.36 308.5 33.98L22.22 136.7C8.719 141.5 0 153.8 0 167.1s8.719 26.47 22.22 31.31L48 208.6v113.1l-31.59 138.8c-1.094 4.75 .0469 9.719 3.078 13.53S27.13 480 32.01 480h63.98c4.859 0 9.461-2.219 12.49-6c3.047-3.781 4.188-8.75 3.125-13.5L80 319.6V220l228.5 81.99c3.703 1.313 7.578 1.938 11.47 1.938c3.906 0 7.812-.6563 11.56-1.969l286.2-102.7C631.3 194.5 640 182.2 640 167.1S631.3 141.5 617.8 136.7zM52.08 447.1l12.09-52.75l11.84 52.75H52.08zM319.3 271.9L129.5 203.8l195.2-60.5c8.438-2.625 13.2-11.55 10.57-20.02c-2.609-8.407-11.49-13.23-20.01-10.55L79.4 185.8L32 168l288.7-103.9L608 168L319.3 271.9zM482.3 288.1c-8.766 1.156-14.94 9.188-13.78 17.97l11.36 86.63c1.156 8.907-4.656 17.66-14.8 22.34c-43.91 20.31-93.56 31.72-143.2 32.94H318.5c-50.02-1.219-99.67-12.63-143.6-32.94c-10.14-4.688-15.95-13.44-14.8-22.31L171.5 306.1c1.156-8.782-5.016-16.81-13.78-17.97C148.8 286.9 140.9 293.2 139.8 301.9l-11.36 86.69c-3.016 23.03 9.969 44.85 33.08 55.53C209.4 466.2 263.4 478.7 318.1 480h4.141c54.36-1.344 108.4-13.75 156.2-35.88c23.11-10.69 36.09-32.5 33.08-55.56l-11.36-86.66C499.1 293.2 491.1 286.9 482.3 288.1z" />
        if (item == "grid-2") icon = <path d="M192 176C192 202.5 170.5 224 144 224H48C21.49 224 0 202.5 0 176V80C0 53.49 21.49 32 48 32H144C170.5 32 192 53.49 192 80V176zM192 432C192 458.5 170.5 480 144 480H48C21.49 480 0 458.5 0 432V336C0 309.5 21.49 288 48 288H144C170.5 288 192 309.5 192 336V432zM256 80C256 53.49 277.5 32 304 32H400C426.5 32 448 53.49 448 80V176C448 202.5 426.5 224 400 224H304C277.5 224 256 202.5 256 176V80zM448 432C448 458.5 426.5 480 400 480H304C277.5 480 256 458.5 256 432V336C256 309.5 277.5 288 304 288H400C426.5 288 448 309.5 448 336V432z" />
        if (item == "filter") icon = <path d="M304 208h128C440.8 208 448 200.8 448 192s-7.156-16-16-16h-128c-8.844 0-15.1 7.156-15.1 16S295.2 208 304 208zM304 336h192c8.844 0 16-7.156 16-16s-7.156-16-16-16h-192c-8.844 0-15.1 7.156-15.1 16S295.2 336 304 336zM304 80h64c8.844 0 16-7.156 16-16S376.8 48 368 48h-64c-8.844 0-15.1 7.156-15.1 16S295.2 80 304 80zM560 432h-256c-8.844 0-15.1 7.156-15.1 16S295.2 464 304 464h256c8.844 0 16-7.156 16-16S568.8 432 560 432zM224 352c-4.094 0-8.188 1.562-11.31 4.688L144 425.4V48C144 39.16 136.8 32 128 32S112 39.16 112 48v377.4l-68.69-68.69c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62l96 96c6.25 6.25 16.38 6.25 22.62 0l96-96c6.25-6.25 6.25-16.38 0-22.62C232.2 353.6 228.1 352 224 352z" />
        if (item == "export") icon = <path d="M571.3 308.7l-96-96c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62L521.4 304H208C199.2 304 192 311.2 192 320s7.156 16 16 16h313.4l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.62C455.8 430.4 459.9 432 464 432s8.188-1.562 11.31-4.688l96-96C577.6 325.1 577.6 314.9 571.3 308.7zM368 384c-8.836 0-16 7.164-16 16V448c0 17.67-14.33 32-32 32H64c-17.67 0-32-14.33-32-32V64c0-17.67 14.33-32 32-32h128v112C192 170.5 213.5 192 240 192H352v48C352 248.8 359.2 256 368 256C376.8 256 384 248.8 384 240V170.5c0-16.97-6.742-33.26-18.75-45.26L258.7 18.74C246.7 6.742 230.5 0 213.5 0H63.1C28.65 0 0 28.65 0 64l.0065 384c0 35.35 28.66 64 64 64H320c35.35 0 64-28.65 64-64v-48C384 391.2 376.8 384 368 384zM224 34.08c4.477 1.566 8.666 3.846 12.12 7.299l106.5 106.5C346.1 151.3 348.4 155.5 349.9 160H240C231.2 160 224 152.8 224 144V34.08z" fill="currentColor" />
        if (item == "mobile") icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M288 0H96C60.65 0 32 28.65 32 64v384c0 35.35 28.65 64 64 64h192c35.35 0 64-28.65 64-64V64C352 28.65 323.3 0 288 0zM160 32h64v16H160V32zM320 448c0 17.64-14.36 32-32 32H96c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h32v16c0 17.64 14.36 32 32 32h64c17.64 0 32-14.36 32-32V32h32c17.64 0 32 14.36 32 32V448zM224 400H160c-8.836 0-16 7.162-16 16c0 8.836 7.164 16 16 16h64c8.836 0 16-7.164 16-16C240 407.2 232.8 400 224 400z" /></svg>
        if (item == "phone") icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M1.153 382.4l21.8 94.47C27.72 497.6 45.89 512 67.12 512C312.4 512 512 312.4 512 67.12c0-21.22-14.47-39.34-35.17-44.06l-94.39-21.91c-21.2-4.891-43.09 6.125-51.81 26.22L287 129.2c-7.984 18.69-2.828 39.92 12.84 52.84l40.52 33.19c-28.7 52.73-72.56 96.59-125.3 125.3L181.9 300C169.4 284.6 147.7 279.3 129.2 286.1L27.4 330.6c-.0156 .0313 .0156 0 0 0C7.317 339.3-3.738 361.1 1.153 382.4zM32.34 375.2c-1.438-6.25 1.813-12.66 7.719-15.22l101.6-43.56c5.344-2.219 11.8-.7188 15.5 3.844l41.39 50.5c4.703 5.75 12.8 7.531 19.44 4.219c67.83-33.38 123.6-89.09 156.9-156.9c3.281-6.672 1.531-14.72-4.219-19.44L320.2 157.3c-4.578-3.781-6.109-10.03-3.75-15.55l43.58-101.7c2.141-4.938 7.016-8.031 12.25-8.031c.9844 0 1.984 .1094 2.984 .3438l94.41 21.91c6.109 1.391 10.34 6.688 10.34 12.88c0 227.7-185.2 412.9-412.9 412.9c-6.141 0-11.61-4.344-12.98-10.31L32.34 375.2z" /></svg>
        if (item == "country") icon = <path d="M289 0a256 256 0 1 0 0 512 256 256 0 0 0 0-512zm46 475v-43c0-26-21-48-48-48h-19c-4 0-13-3-16-5l-23-17c-3-3-5-7-5-11v-24c0-4 2-9 6-11l43-26 7-2h32c3 0 6 1 8 3l53 45h30l17 17c10 10 22 15 36 15h27c-31 54-84 94-148 107zm163-139h-42c-5 0-10-2-13-5l-18-18c-6-6-14-9-22-9h-18l-44-37c-8-7-18-11-29-11h-31c-9 0-17 2-24 7l-43 25c-13 8-22 23-22 39v24c0 14 7 28 18 37l23 16c8 7 24 12 35 12h20c9 0 16 7 16 16v47l-15 1a224 224 0 0 1 0-448h5l-22 19c-10 8-16 19-16 32v23c0 6 3 17 6 22l-25 19c-8 8-13 20-13 32v16c0 25 20 45 45 45h26c11 0 21-3 29-10l13 2h13c26 0 32-20 36-22 5 10 14 17 23 20-4 14 0 30 11 42l18 19c9 9 20 14 33 14h37l-10 31zm-27-64c-4 0-7-1-10-4l-18-19c-4-4-4-10 0-14 12-13 10-9 10-18 0-2-1-5-3-6l-8-8c-1-2-4-3-6-3h-14a9 9 0 0 1-6-16l8-8 6-2h9c5 0 9-5 9-10v-10c0-5-4-10-9-10h-29c-7 0-13 6-13 14v5c0 6-4 11-9 13l-27 9c-4 1-4 5-4 8 0 4-3 7-7 7h-13c-4 0-7-3-7-7 0-5-4-7-8-7-3 0-6 2-7 4-9 12-12 18-20 18h-26c-7 0-13-6-13-13v-17c0-3 1-7 4-9 19-14 30-18 30-32 0-2 1-5 4-6l34-11 3-2 23-23c5-5 3-15-7-15h-17l-13 19v7c0 3-4 6-7 6h-15c-4 0-7-3-7-6V83c0-3 1-5 3-6l46-40a224 224 0 0 1 176 219l-1 16h-41zM224 119a13 13 0 0 0-22-9l-28 29c-3 2-4 5-4 9 0 7 6 12 13 12h18l9-3 10-11c3-2 4-5 4-9v-18z" fill="currentColor" />
        if (item == "city") icon = <path d="M176 296v-48c0-13-11-24-24-24h-48c-13 0-24 11-24 24v48c0 13 11 24 24 24h48c13 0 24-11 24-24zm-32-8h-32v-32h32v32zm-40-96h48c13 0 24-11 24-24v-48c0-13-11-24-24-24h-48c-13 0-24 11-24 24v48c0 13 11 24 24 24zm8-64h32v32h-32v-32zm80 256c-35 0-64 28-64 64v48c0 9 7 16 16 16s16-7 16-17v-48c0-18 14-31 32-31s32 13 32 31v48c0 9 7 16 16 16s16-7 16-16v-48c0-34-29-63-64-63zm88-288h-48c-13 0-24 11-24 24v48c0 13 11 24 24 24h48c13 0 24-11 24-24v-48c0-13-11-24-24-24zm-8 64h-32v-32h32v32zM320 0H64C29 0 0 29 0 64v432a16 16 0 0 0 32 0V64c0-18 14-32 32-32h256c18 0 32 14 32 32v432a16 16 0 0 0 32 0V64c0-35-29-64-64-64zm-40 224h-48c-13 0-24 11-24 24v48c0 13 11 24 24 24h48c13 0 24-11 24-24v-48c0-13-11-24-24-24zm-8 64h-32v-32h32v32z" fill="currentColor" />
        if (item == "article") icon = <path d="M625.9 42.2l-28.13-28.14c-9.373-9.373-21.66-14.06-33.94-14.06s-24.57 4.688-33.94 14.06l-175.5 175.5c-8.936 8.936-15.03 20.32-17.5 32.71l-16.66 83.35C318.7 313.2 324.6 320 331.1 320c.7852 0 1.586-.0781 2.398-.2402l83.35-16.67c12.39-2.479 23.77-8.566 32.7-17.5l175.5-175.5C644.7 91.34 644.7 60.95 625.9 42.2zM427.8 262.1c-4.48 4.48-10.13 7.506-16.35 8.748L357.5 282.5l10.78-53.93c1.244-6.219 4.27-11.88 8.754-16.36l114.3-114.3l50.76 50.76L427.8 262.1zM603.3 87.45l-38.62 38.62l-50.76-50.76l38.62-38.62c4.076-4.076 8.838-4.686 11.31-4.686s7.236 .6094 11.31 4.686l28.13 28.14C607.4 68.9 608 73.66 608 76.14C608 78.62 607.4 83.38 603.3 87.45zM592 208C583.2 208 576 215.2 576 224v224c0 17.67-14.33 32-32 32H96c-17.67 0-32-14.33-32-32V192c0-17.67 14.33-32 32-32h224c8.836 0 16-7.164 16-16C336 135.2 328.8 128 320 128H96C60.65 128 32 156.7 32 192v256c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V224C608 215.2 600.8 208 592 208zM112 288h160C280.8 288 288 280.8 288 272C288 263.2 280.8 256 272 256h-160C103.2 256 96 263.2 96 272C96 280.8 103.2 288 112 288zM112 384h416c8.836 0 16-7.164 16-16c0-8.838-7.164-16-16-16h-416C103.2 352 96 359.2 96 368C96 376.8 103.2 384 112 384z" fill="currentColor" />
        if (item == "download") icon = <path d="M224 352c4 0 8-2 11-5l144-144a16 16 0 1 0-22-22L240 297V16a16 16 0 0 0-32 0v281L91 181a16 16 0 1 0-22 22l144 144c3 3 7 5 11 5zm224 80v-96a16 16 0 1 0-32 0v96c0 26-22 48-48 48H80c-26 0-48-21-48-48v-96a16 16 0 0 0-32 0v96c0 44 36 80 80 80h288c44 0 80-36 80-80z" fill="currentColor" />
        if (item == "pen") icon = <path d="M493.2 56.26l-37.51-37.51C443.2 6.252 426.8 0 410.5 0c-16.38 0-32.76 6.25-45.26 18.75L45.11 338.9c-8.568 8.566-14.53 19.39-17.18 31.21l-27.61 122.8C-1.7 502.1 6.158 512 15.95 512c1.047 0 2.116-.1034 3.198-.3202c0 0 84.61-17.95 122.8-26.93c11.54-2.717 21.87-8.523 30.25-16.9l321.2-321.2C518.3 121.7 518.2 81.26 493.2 56.26zM149.5 445.2c-4.219 4.219-9.252 7.039-14.96 8.383c-24.68 5.811-69.64 15.55-97.46 21.52l22.04-98.01c1.332-5.918 4.303-11.31 8.594-15.6l247.6-247.6l82.76 82.76L149.5 445.2zM470.7 124l-50.03 50.02l-82.76-82.76l49.93-49.93C393.9 35.33 401.9 32 410.5 32s16.58 3.33 22.63 9.375l37.51 37.51C483.1 91.37 483.1 111.6 470.7 124z" fill="currentColor" />
        if (item == "heart") icon = <path d="M462.3 62.71c-54.5-46.5-136.1-38.99-186.6 13.27l-19.69 20.61l-19.71-20.61C195.6 33.85 113.3 8.71 49.76 62.71C-13.11 116.2-16.31 212.5 39.81 270.5l193.2 199.7C239.3 476.7 247.8 480 255.9 480c8.25 0 16.33-3.25 22.58-9.751l193.6-199.8C528.5 212.5 525.1 116.2 462.3 62.71zM449.3 248.2l-192.9 199.9L62.76 248.2C24.39 208.7 16.39 133.2 70.51 87.09C125.3 40.21 189.8 74.22 213.3 98.59l42.75 44.13l42.75-44.13c23.13-24 88.13-58 142.8-11.5C495.5 133.1 487.6 208.6 449.3 248.2z" fill="currentColor" />
        if (item == "location") icon = <path d="M272 192C272 236.2 236.2 272 192 272C147.8 272 112 236.2 112 192C112 147.8 147.8 112 192 112C236.2 112 272 147.8 272 192zM192 240C218.5 240 240 218.5 240 192C240 165.5 218.5 144 192 144C165.5 144 144 165.5 144 192C144 218.5 165.5 240 192 240zM384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192H384zM192 32C103.6 32 32 103.6 32 192C32 207.6 37.43 229 48.56 255.4C59.47 281.3 74.8 309.4 92.14 337.5C126.2 392.8 166.6 445.7 192 477.6C217.4 445.7 257.8 392.8 291.9 337.5C309.2 309.4 324.5 281.3 335.4 255.4C346.6 229 352 207.6 352 192C352 103.6 280.4 32 192 32z" />
        if (item == "warning") icon = <path d="M466.5 83.69l-192-80.01C268.6 1.188 262.3 0 256.1 0S243.5 1.188 237.6 3.688l-192 80.01C27.72 91.07 16 108.6 16 127.1C16 385.4 205.4 512 255.1 512C305.2 512 496 387.3 496 127.1C496 108.6 484.3 91.07 466.5 83.69zM463.9 128.3c0 225.3-166.2 351.7-207.8 351.7C213.3 479.1 48 352.2 48 128c0-6.5 3.875-12.25 9.75-14.75l192-80c1.973-.8275 4.109-1.266 6.258-1.266c2.071 0 4.154 .4072 6.117 1.266l192 80C463.3 117.1 463.9 125.8 463.9 128.3zM256 288c8.844 0 16-7.156 16-16v-128C272 135.2 264.8 128 256 128S240 135.2 240 144v128C240 280.8 247.2 288 256 288zM256 328c-13.25 0-24 10.75-24 24s10.75 24 24 24c13.26 0 24-10.75 24-24S269.3 328 256 328z" />
        if (item == "copy") icon = <path d="M272 416C263.2 416 256 423.2 256 432V448c0 17.67-14.33 32-32 32H64c-17.67 0-32-14.33-32-32V192c0-17.67 14.33-32 32-32h112C184.8 160 192 152.8 192 144C192 135.2 184.8 128 176 128H63.99c-35.35 0-64 28.65-64 64l.0098 256C0 483.3 28.65 512 64 512h160c35.35 0 64-28.65 64-64v-16C288 423.2 280.8 416 272 416zM502.6 86.63l-77.25-77.25C419.4 3.371 411.2 0 402.7 0H288C252.7 0 224 28.65 224 64v256c0 35.35 28.65 64 64 64h160c35.35 0 64-28.65 64-64V109.3C512 100.8 508.6 92.63 502.6 86.63zM416 45.25L466.7 96H416V45.25zM480 320c0 17.67-14.33 32-32 32h-160c-17.67 0-32-14.33-32-32V64c0-17.67 14.33-32 32-32h96l.0026 64c0 17.67 14.33 32 32 32H480V320z" />
        if (item == "print") icon = <path d="M416 320H96c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-128C448 334.3 433.7 320 416 320zM416 480H96v-128h320V480zM448 192V70.63C448 62.14 444.6 54 438.6 48l-38.63-38.63C393.1 3.37 385.9 0 377.4 0H128C92.65 0 64 28.65 64 64v128C28.7 192 0 220.7 0 256v112C0 376.8 7.156 384 16 384S32 376.8 32 368V256c0-17.67 14.33-32 32-32h384c17.67 0 32 14.33 32 32v112c0 8.844 7.156 16 16 16s16-7.156 16-16V256C512 220.7 483.3 192 448 192zM416 192H96V64c0-17.67 14.33-32 32-32h249.4L416 70.63V192zM432 248c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24s24-10.75 24-24C456 258.7 445.3 248 432 248z" />
        if (item == "edit") icon = <path d="M514.7 23.11C539.6-2.142 580.4-2.267 605.5 22.83L617.4 34.75C642.4 59.74 642.4 100.3 617.4 125.3L424.9 317.8C416.1 326.6 404.9 332.7 392.8 335.2L307.3 353.2C301.1 354.3 296.5 352.6 292.7 348.8C288.9 344.1 287.2 339.5 288.3 334.2L306.3 248.6C308.8 236.5 314.8 225.5 323.4 216.7L514.7 23.11zM582.8 45.46C570.3 32.91 549.9 32.97 537.4 45.6L510.1 72.37L568 129.4L594.8 102.6C607.3 90.13 607.2 69.87 594.8 57.38L582.8 45.46zM337.6 255.1L324.7 316.8L386.2 303.9C392.3 302.6 397.9 299.6 402.3 295.2L545.4 152L488.5 95.14L346.2 239.2C341.9 243.6 338.9 249.1 337.6 255.1L337.6 255.1zM304 128C312.8 128 320 135.2 320 144C320 152.8 312.8 160 304 160H64C46.33 160 32 174.3 32 192V448C32 465.7 46.33 480 64 480H512C529.7 480 544 465.7 544 448V272C544 263.2 551.2 256 560 256C568.8 256 576 263.2 576 272V448C576 483.3 547.3 512 512 512H64C28.65 512 0 483.3 0 448V192C0 156.7 28.65 128 64 128H304zM104 320C104 306.7 114.7 296 128 296C141.3 296 152 306.7 152 320C152 333.3 141.3 344 128 344C114.7 344 104 333.3 104 320zM248 320C248 333.3 237.3 344 224 344C210.7 344 200 333.3 200 320C200 306.7 210.7 296 224 296C237.3 296 248 306.7 248 320z" />
        if (item == "paperclip") icon = <path d="M380.7 67.31C351.6 38.22 304.4 38.22 275.3 67.31L83.31 259.3C36.54 306.1 36.54 381.9 83.31 428.7C130.1 475.5 205.9 475.5 252.7 428.7L404.7 276.7C410.9 270.4 421.1 270.4 427.3 276.7C433.6 282.9 433.6 293.1 427.3 299.3L275.3 451.3C216 510.6 119.1 510.6 60.69 451.3C1.417 392 1.418 295.1 60.69 236.7L252.7 44.69C294.3 3.092 361.7 3.092 403.3 44.69C444.9 86.28 444.9 153.7 403.3 195.3L219.5 379.1C191.3 407.3 144.9 404.7 119.1 373.6C98.67 346.1 100.8 308.6 124.9 284.5L276.7 132.7C282.9 126.4 293.1 126.4 299.3 132.7C305.6 138.9 305.6 149.1 299.3 155.3L147.5 307.1C134.1 319.7 133.8 339.7 144.1 353.6C157.1 369.8 182.2 371.2 196.9 356.5L380.7 172.7C409.8 143.6 409.8 96.41 380.7 67.31L380.7 67.31z" />
        if (item == "share") icon = <path d="M448 112C448 156.2 412.2 192 368 192C345.1 192 324.4 182.4 309.9 166.1L158.9 242.5C159.6 246.9 160 251.4 160 256C160 260.6 159.6 265.1 158.9 269.5L309.9 345C324.4 329.6 345.1 320 368 320C412.2 320 448 355.8 448 400C448 444.2 412.2 480 368 480C323.8 480 288 444.2 288 400C288 390.3 289.7 380.1 292.9 372.3L147.2 299.5C132.9 321.5 108.2 336 80 336C35.82 336 0 300.2 0 256C0 211.8 35.82 176 80 176C108.2 176 132.9 190.5 147.2 212.5L292.9 139.7C289.7 131 288 121.7 288 112C288 67.82 323.8 32 368 32C412.2 32 448 67.82 448 112L448 112zM79.1 304C106.5 304 127.1 282.5 127.1 256C127.1 229.5 106.5 208 79.1 208C53.49 208 31.1 229.5 31.1 256C31.1 282.5 53.49 304 79.1 304zM368 64C341.5 64 320 85.49 320 112C320 138.5 341.5 160 368 160C394.5 160 416 138.5 416 112C416 85.49 394.5 64 368 64zM368 448C394.5 448 416 426.5 416 400C416 373.5 394.5 352 368 352C341.5 352 320 373.5 320 400C320 426.5 341.5 448 368 448z" />
        if (item == "envelope") icon = <path d="M0 128C0 92.65 28.65 64 64 64H448C483.3 64 512 92.65 512 128V384C512 419.3 483.3 448 448 448H64C28.65 448 0 419.3 0 384V128zM32 128V167.9L227.6 311.3C244.5 323.7 267.5 323.7 284.4 311.3L480 167.9V128C480 110.3 465.7 96 448 96H63.1C46.33 96 31.1 110.3 31.1 128H32zM32 207.6V384C32 401.7 46.33 416 64 416H448C465.7 416 480 401.7 480 384V207.6L303.3 337.1C275.1 357.8 236.9 357.8 208.7 337.1L32 207.6z" />
        if (item == "minus") icon = <path d="M432 256C432 264.8 424.8 272 416 272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h384C424.8 240 432 247.2 432 256z" />
        if (item == "plus") icon = <path d="M432 256C432 264.8 424.8 272 416 272h-176V448c0 8.844-7.156 16.01-16 16.01S208 456.8 208 448V272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h176V64c0-8.844 7.156-15.99 16-15.99S240 55.16 240 64v176H416C424.8 240 432 247.2 432 256z" />
        if (item == "heart-plus") icon = <path d="M255.1 96L267.1 84.02C300.6 51.37 347 36.51 392.6 44.1C461.5 55.58 512 115.2 512 185.1V190.9C512 232.4 494.8 272.1 464.4 300.4L283.7 469.1C276.2 476.1 266.3 480 256 480C245.7 480 235.8 476.1 228.3 469.1L47.59 300.4C17.23 272.1 0 232.4 0 190.9V185.1C0 115.2 50.52 55.58 119.4 44.1C164.1 36.51 211.4 51.37 244 84.02L255.1 96zM255.1 141.3L221.4 106.6C196.1 81.31 160 69.77 124.7 75.66C71.21 84.58 31.1 130.9 31.1 185.1V190.9C31.1 223.6 45.55 254.7 69.42 277L250.1 445.7C251.7 447.2 253.8 448 255.1 448C258.2 448 260.3 447.2 261.9 445.7L442.6 277C466.4 254.7 480 223.6 480 190.9V185.1C480 130.9 440.8 84.58 387.3 75.66C351.1 69.77 315.9 81.31 290.6 106.6L255.1 141.3z" />
        if (item == "badge-check") icon = <path d="M235.3 331.3C229.1 337.6 218.9 337.6 212.7 331.3L156.7 275.3C150.4 269.1 150.4 258.9 156.7 252.7C162.9 246.4 173.1 246.4 179.3 252.7L224 297.4L324.7 196.7C330.9 190.4 341.1 190.4 347.3 196.7C353.6 202.9 353.6 213.1 347.3 219.3L235.3 331.3zM343.1 45.63C376.1 39.67 411.5 49.43 437 74.98C462.6 100.5 472.3 135.9 466.4 168.9C493.9 187.1 512 219.9 512 255.1C512 292.1 493.9 324 466.4 343.1C472.3 376.1 462.6 411.5 437 437C411.5 462.6 376.1 472.3 343.1 466.4C324 493.9 292.1 512 256 512C219.9 512 187.1 493.9 168.9 466.4C135.9 472.3 100.5 462.6 74.98 437C49.43 411.5 39.67 376.1 45.63 343.1C18.08 324 0 292.1 0 255.1C0 219.9 18.08 187.1 45.63 168.9C39.67 135.9 49.43 100.5 74.98 74.98C100.5 49.43 135.9 39.67 168.9 45.63C187.1 18.08 219.9 0 255.1 0C292.1 0 324 18.08 343.1 45.63L343.1 45.63zM184.4 83.08L171.7 79.2C146.3 71.4 117.6 77.57 97.61 97.61C77.57 117.6 71.4 146.3 79.2 171.7L83.08 184.4L71.4 190.6C47.93 203 32 227.7 32 255.1C32 284.3 47.93 308.1 71.4 321.4L83.08 327.6L79.2 340.3C71.4 365.7 77.57 394.3 97.61 414.4C117.6 434.4 146.3 440.6 171.7 432.8L184.4 428.9L190.6 440.6C203 464.1 227.7 480 256 480C284.3 480 308.1 464.1 321.4 440.6L327.6 428.9L340.3 432.8C365.7 440.6 394.3 434.4 414.4 414.4C434.4 394.3 440.6 365.7 432.8 340.3L428.9 327.6L440.6 321.4C464.1 308.1 480 284.3 480 255.1C480 227.7 464.1 203 440.6 190.6L428.9 184.4L432.8 171.7C440.6 146.3 434.4 117.6 414.4 97.6C394.4 77.56 365.7 71.4 340.3 79.2L327.6 83.08L321.4 71.4C308.1 47.93 284.3 31.1 256 31.1C227.7 31.1 203 47.93 190.6 71.4L184.4 83.08z" />
        if (item == "seal-question") icon = <path d="M168.7 169.8C175.2 145.2 197.4 128 222.9 128H280C315.5 128 344 157 344 192.3C344 216.3 330.6 238.5 309.1 249.4L272 268.3V288C272 296.8 264.8 304 256 304C247.2 304 240 296.8 240 288V258.5C240 252.5 243.4 247 248.7 244.3L294.5 220.9C305.2 215.5 312 204.3 312 192.3C312 174.5 297.6 160 280 160H222.9C211.1 160 202.4 167.4 199.7 177.9L199.5 178.6C197.2 187.1 188.5 192.3 179.9 190C171.4 187.8 166.3 179 168.5 170.5L168.7 169.8zM280 352C280 365.3 269.3 376 256 376C242.7 376 232 365.3 232 352C232 338.7 242.7 328 256 328C269.3 328 280 338.7 280 352zM64 176V112C64 85.49 85.49 64 112 64H175.1L222.1 17.94C240.8-.8035 271.2-.8035 289.9 17.94L336 64H400C426.5 64 448 85.49 448 112V176L493.6 221.6C512.3 240.3 512.3 270.7 493.6 289.5L448 335.1V400C448 426.5 426.5 448 400 448H335.1L289.9 493.1C271.2 511.9 240.8 511.9 222.1 493.1L176.9 448H112C85.49 448 64 426.5 64 400V335.1L18.41 289.5C-.3328 270.7-.3328 240.3 18.41 221.6L64 176zM112 96C103.2 96 96 103.2 96 112V176C96 184.5 92.63 192.6 86.63 198.6L41.04 244.2C34.79 250.5 34.79 260.6 41.04 266.8L86.63 312.4C92.63 318.4 96 326.6 96 335.1V400C96 408.8 103.2 416 112 416H176.9C185.4 416 193.6 419.4 199.6 425.4L244.7 470.5C250.9 476.7 261.1 476.7 267.3 470.5L312.4 425.4C318.4 419.4 326.6 416 335.1 416H400C408.8 416 416 408.8 416 400V335.1C416 326.6 419.4 318.4 425.4 312.4L470.1 266.8C477.2 260.6 477.2 250.5 470.1 244.2L425.4 198.6C419.4 192.6 416 184.5 416 176V112C416 103.2 408.8 96 400 96H336C327.5 96 319.4 92.63 313.4 86.63L267.3 40.57C261.1 34.32 250.9 34.32 244.7 40.57L198.6 86.63C192.6 92.63 184.5 96 175.1 96L112 96zM18.41 289.5L41.04 266.8z" />
        if (item == "message-pen") icon = <path d="M256 31.1c-141.4 0-255.1 93.13-255.1 208c0 47.62 19.91 91.25 52.91 126.3c-14.87 39.5-45.87 72.88-46.37 73.25c-6.623 7-8.373 17.25-4.623 26C5.816 474.3 14.38 480 24 480c61.49 0 109.1-25.75 139.1-46.25c28.1 9 60.16 14.25 92.9 14.25c141.4 0 255.1-93.13 255.1-207.1S397.4 31.1 256 31.1zM256 416c-28.25 0-56.24-4.25-83.24-12.75c-9.516-3.068-19.92-1.461-28.07 4.338c-22.1 16.25-58.54 35.29-102.7 39.66c11.1-15.12 29.75-40.5 40.74-69.63l.1289-.3398c4.283-11.27 1.791-23.1-6.43-32.82C47.51 313.1 32.06 277.6 32.06 240c0-97 100.5-176 223.1-176c123.5 0 223.1 79 223.1 176S379.5 416 256 416zM345.5 141.1c-7.617-7.559-17.5-12.83-28.23-13.78c-13.24-1.172-25.9 3.414-35.16 12.59L157.9 264.1c-2.234 2.215-3.754 5.039-4.375 8.113l-12.25 60.79c-2.234 11.11 7.633 20.91 18.83 18.68l61.25-12.15c3.094-.6133 5.938-2.125 8.172-4.344l123.1-122.2c7.617-7.555 12.92-17.37 13.87-28.02c1.168-13.14-3.457-25.7-12.71-34.88L345.5 141.1zM210.3 309.3L177.3 315.9l6.594-32.71l86.88-86.23l26.38 26.18L210.3 309.3zM331.1 189.4l-11.3 11.22l-26.38-26.18l11.31-11.22c4.688-4.645 12.28-4.652 16.97 .0039l9.41 9.336C335.8 177.2 335.8 184.8 331.1 189.4z" />
        if (item == "like") icon = <path d="M88 192h-48C17.94 192 0 209.9 0 232v208C0 462.1 17.94 480 40 480h48C110.1 480 128 462.1 128 440v-208C128 209.9 110.1 192 88 192zM96 440C96 444.4 92.41 448 88 448h-48C35.59 448 32 444.4 32 440v-208C32 227.6 35.59 224 40 224h48C92.41 224 96 227.6 96 232V440zM512 221.5C512 187.6 484.4 160 450.5 160h-102.5c11.98-27.06 18.83-53.48 18.83-67.33C366.9 62.84 343.6 32 304.9 32c-41.22 0-50.7 29.11-59.12 54.81C218.1 171.1 160 184.8 160 208C160 217.1 167.5 224 176 224C180.1 224 184.2 222.4 187.3 219.3c52.68-53.04 67.02-56.11 88.81-122.5C285.3 68.95 288.2 64 304.9 64c20.66 0 29.94 16.77 29.94 28.67c0 10.09-8.891 43.95-26.62 75.48c-1.366 2.432-2.046 5.131-2.046 7.83C306.2 185.5 314 192 322.2 192h128.3C466.8 192 480 205.2 480 221.5c0 15.33-12.08 28.16-27.48 29.2c-8.462 .5813-14.91 7.649-14.91 15.96c0 12.19 12.06 12.86 12.06 30.63c0 14.14-10.11 26.3-24.03 28.89c-5.778 1.082-13.06 6.417-13.06 15.75c0 8.886 6.765 10.72 6.765 23.56c0 31.02-31.51 22.12-31.51 43.05c0 3.526 1.185 5.13 1.185 10.01C389 434.8 375.8 448 359.5 448H303.9c-82.01 0-108.3-64.02-127.9-64.02c-8.873 0-16 7.193-16 15.96C159.1 416.3 224.6 480 303.9 480h55.63c33.91 0 61.5-27.58 61.5-61.47c18.55-10.86 30.33-31 30.33-53.06c0-4.797-.5938-9.594-1.734-14.27c19.31-10.52 32.06-30.97 32.06-53.94c0-7.219-1.281-14.31-3.75-20.98C498.2 266.2 512 245.3 512 221.5z" />
        if (item == "dislike") icon = <path d="M128 280v-208C128 49.94 110.1 32 88 32h-48C17.94 32 0 49.94 0 72v208C0 302.1 17.94 320 40 320h48C110.1 320 128 302.1 128 280zM96 280C96 284.4 92.41 288 88 288h-48C35.59 288 32 284.4 32 280v-208C32 67.59 35.59 64 40 64h48C92.41 64 96 67.59 96 72V280zM477.9 235.7c2.469-6.672 3.75-13.77 3.75-20.98c0-22.97-12.75-43.42-32.06-53.94c1.141-4.672 1.734-9.469 1.734-14.27c0-22.06-11.78-41.94-30.33-52.8C421 59.84 393.4 32 359.5 32H303.9c-77.41 0-143.9 63.11-143.9 80.07c0 8.767 7.133 15.96 16 15.96C195.8 128 222.2 64 303.9 64h55.63c16.27 0 29.5 13.22 29.5 29.47c0 4.826-1.185 6.491-1.185 10.01c0 20.94 31.51 12.09 31.51 43.05c0 12.84-6.765 14.68-6.765 23.56c0 9.347 7.255 14.66 13.06 15.75c13.92 2.594 24.03 14.75 24.03 28.89c0 17.77-12.06 18.45-12.06 30.63c0 8.314 6.443 15.38 14.91 15.96C467.9 262.4 480 275.2 480 290.5C480 306.8 466.8 320 450.5 320h-128.3c-8.273 0-15.1 6.658-15.1 16.01c0 2.699 .68 5.398 2.046 7.83c17.73 31.53 26.62 65.39 26.62 75.48C334.9 431.2 325.6 448 304.9 448c-16.7 0-19.66-4.953-28.78-32.78c-21.79-66.41-36.14-69.47-88.81-122.5C184.2 289.6 180.1 288 176 288C167.4 288 160 294.9 160 303.1c0 23.25 57.94 36.53 85.73 121.2C254.2 450.9 263.6 480 304.9 480c38.77 0 62.01-30.84 62.01-60.67c0-13.84-6.844-40.27-18.83-67.33h102.5C484.4 352 512 324.4 512 290.5C512 266.8 498.2 245.8 477.9 235.7z" />
        if (item == "orcid") icon = <path d="M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z" />
        if (item == "comment") icon = <path d="M256 31.1c-141.4 0-255.1 93.13-255.1 208c0 47.62 19.91 91.25 52.91 126.3c-14.87 39.5-45.87 72.88-46.37 73.25c-6.623 7-8.374 17.25-4.624 26C5.816 474.3 14.38 480 24 480c61.49 0 109.1-25.75 139.1-46.25c28.1 9 60.16 14.25 92.9 14.25c141.4 0 255.1-93.13 255.1-207.1S397.4 31.1 256 31.1zM256 416c-28.25 0-56.24-4.25-83.24-12.75c-9.516-3.068-19.92-1.461-28.07 4.338c-22.1 16.25-58.54 35.29-102.7 39.66c11.1-15.12 29.75-40.5 40.74-69.63l.1289-.3398c4.283-11.27 1.791-23.1-6.43-32.82C47.51 313.1 32.06 277.6 32.06 240c0-97 100.5-176 223.1-176c123.5 0 223.1 79 223.1 176S379.5 416 256 416zM256 216c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24s24-10.75 24-24C280 226.7 269.3 216 256 216zM384 216c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24s24-10.75 24-24C408 226.7 397.3 216 384 216zM128 216c-13.25 0-24 10.74-24 24c0 13.25 10.75 24 24 24S152 253.3 152 240C152 226.7 141.3 216 128 216z" />
        if (item == "cog") icon = <path d="M168 255.1C168 207.4 207.4 167.1 256 167.1C304.6 167.1 344 207.4 344 255.1C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 255.1zM256 199.1C225.1 199.1 200 225.1 200 255.1C200 286.9 225.1 311.1 256 311.1C286.9 311.1 312 286.9 312 255.1C312 225.1 286.9 199.1 256 199.1zM65.67 230.6L25.34 193.8C14.22 183.7 11.66 167.2 19.18 154.2L49.42 101.8C56.94 88.78 72.51 82.75 86.84 87.32L138.8 103.9C152.2 93.56 167 84.96 182.8 78.43L194.5 25.16C197.7 10.47 210.7 0 225.8 0H286.2C301.3 0 314.3 10.47 317.5 25.16L329.2 78.43C344.1 84.96 359.8 93.56 373.2 103.9L425.2 87.32C439.5 82.75 455.1 88.78 462.6 101.8L492.8 154.2C500.3 167.2 497.8 183.7 486.7 193.8L446.3 230.6C447.4 238.9 448 247.4 448 255.1C448 264.6 447.4 273.1 446.3 281.4L486.7 318.2C497.8 328.3 500.3 344.8 492.8 357.8L462.6 410.2C455.1 423.2 439.5 429.2 425.2 424.7L373.2 408.1C359.8 418.4 344.1 427 329.2 433.6L317.5 486.8C314.3 501.5 301.3 512 286.2 512H225.8C210.7 512 197.7 501.5 194.5 486.8L182.8 433.6C167 427 152.2 418.4 138.8 408.1L86.84 424.7C72.51 429.2 56.94 423.2 49.42 410.2L19.18 357.8C11.66 344.8 14.22 328.3 25.34 318.2L65.67 281.4C64.57 273.1 64 264.6 64 255.1C64 247.4 64.57 238.9 65.67 230.6V230.6zM158.4 129.2L145.1 139.5L77.13 117.8L46.89 170.2L99.58 218.2L97.39 234.8C96.47 241.7 96 248.8 96 255.1C96 263.2 96.47 270.3 97.39 277.2L99.58 293.8L46.89 341.8L77.13 394.2L145.1 372.5L158.4 382.8C169.5 391.4 181.9 398.6 195 403.1L210.5 410.4L225.8 480H286.2L301.5 410.4L316.1 403.1C330.1 398.6 342.5 391.4 353.6 382.8L366.9 372.5L434.9 394.2L465.1 341.8L412.4 293.8L414.6 277.2C415.5 270.3 416 263.2 416 256C416 248.8 415.5 241.7 414.6 234.8L412.4 218.2L465.1 170.2L434.9 117.8L366.9 139.5L353.6 129.2C342.5 120.6 330.1 113.4 316.1 108L301.5 101.6L286.2 32H225.8L210.5 101.6L195 108C181.9 113.4 169.5 120.6 158.4 129.2H158.4z" />
        if (item == "check") icon = <path d="M443.3 100.7C449.6 106.9 449.6 117.1 443.3 123.3L171.3 395.3C165.1 401.6 154.9 401.6 148.7 395.3L4.686 251.3C-1.562 245.1-1.562 234.9 4.686 228.7C10.93 222.4 21.06 222.4 27.31 228.7L160 361.4L420.7 100.7C426.9 94.44 437.1 94.44 443.3 100.7H443.3z" />
        if (item == "condition") icon = <path d="M235.3 123.3C229.1 129.6 218.9 129.6 212.7 123.3C206.4 117.1 206.4 106.9 212.7 100.7L308.7 4.686C314.9-1.562 325.1-1.562 331.3 4.686L427.3 100.7C433.6 106.9 433.6 117.1 427.3 123.3C421.1 129.6 410.9 129.6 404.7 123.3L336 54.63V400C336 444.2 371.8 480 416 480H496C504.8 480 512 487.2 512 496C512 504.8 504.8 512 496 512H416C354.1 512 304 461.9 304 400V384C304 339.8 268.2 304 224 304H54.63L123.3 372.7C129.6 378.9 129.6 389.1 123.3 395.3C117.1 401.6 106.9 401.6 100.7 395.3L4.686 299.3C1.686 296.3 0 292.2 0 288C0 283.8 1.686 279.7 4.686 276.7L100.7 180.7C106.9 174.4 117.1 174.4 123.3 180.7C129.6 186.9 129.6 197.1 123.3 203.3L54.63 272H224C255.3 272 283.7 284.9 304 305.6V54.63L235.3 123.3z" />
        if (item == "check_one") icon = <path d="M64 112C55.16 112 48 104.8 48 96C48 87.16 55.16 80 64 80C72.84 80 80 87.16 80 96C80 104.8 72.84 112 64 112zM64 160C28.65 160 0 131.3 0 96C0 60.65 28.65 32 64 32C99.35 32 128 60.65 128 96C128 131.3 99.35 160 64 160zM96 96C96 78.33 81.67 64 64 64C46.33 64 32 78.33 32 96C32 113.7 46.33 128 64 128C81.67 128 96 113.7 96 96zM192 96C192 87.16 199.2 80 208 80H496C504.8 80 512 87.16 512 96C512 104.8 504.8 112 496 112H208C199.2 112 192 104.8 192 96zM192 256C192 247.2 199.2 240 208 240H496C504.8 240 512 247.2 512 256C512 264.8 504.8 272 496 272H208C199.2 272 192 264.8 192 256zM192 416C192 407.2 199.2 400 208 400H496C504.8 400 512 407.2 512 416C512 424.8 504.8 432 496 432H208C199.2 432 192 424.8 192 416zM64 192C99.35 192 128 220.7 128 256C128 291.3 99.35 320 64 320C28.65 320 0 291.3 0 256C0 220.7 28.65 192 64 192zM32 256C32 273.7 46.33 288 64 288C81.67 288 96 273.7 96 256C96 238.3 81.67 224 64 224C46.33 224 32 238.3 32 256zM64 480C28.65 480 0 451.3 0 416C0 380.7 28.65 352 64 352C99.35 352 128 380.7 128 416C128 451.3 99.35 480 64 480zM96 416C96 398.3 81.67 384 64 384C46.33 384 32 398.3 32 416C32 433.7 46.33 448 64 448C81.67 448 96 433.7 96 416z" />
        if (item == "check_multi") icon = <path d="M76.29 154.2C73.41 157.7 69.22 159.8 64.72 159.1C60.23 160.2 55.86 158.5 52.69 155.3L4.686 107.3C-1.562 101.1-1.562 90.94 4.686 84.69C10.93 78.44 21.06 78.44 27.31 84.69L62.92 120.3L131.7 37.76C137.4 30.97 147.5 30.05 154.2 35.71C161 41.37 161.9 51.45 156.3 58.24L76.29 154.2zM76.29 314.2C73.41 317.7 69.22 319.8 64.72 319.1C60.23 320.2 55.86 318.5 52.69 315.3L4.686 267.3C-1.562 261.1-1.562 250.9 4.686 244.7C10.93 238.4 21.06 238.4 27.31 244.7L62.92 280.3L131.7 197.8C137.4 190.1 147.5 190.1 154.2 195.7C161 201.4 161.9 211.5 156.3 218.2L76.29 314.2zM191.1 96C191.1 87.16 199.2 80 207.1 80H496C504.8 80 512 87.16 512 96C512 104.8 504.8 112 496 112H207.1C199.2 112 191.1 104.8 191.1 96zM191.1 256C191.1 247.2 199.2 240 207.1 240H496C504.8 240 512 247.2 512 256C512 264.8 504.8 272 496 272H207.1C199.2 272 191.1 264.8 191.1 256zM159.1 416C159.1 407.2 167.2 400 175.1 400H496C504.8 400 512 407.2 512 416C512 424.8 504.8 432 496 432H175.1C167.2 432 159.1 424.8 159.1 416zM63.1 448C46.33 448 31.1 433.7 31.1 416C31.1 398.3 46.33 384 63.1 384C81.67 384 95.1 398.3 95.1 416C95.1 433.7 81.67 448 63.1 448z" />
        if (item == "check_matris_one") icon = <path d="M384 224C357.5 224 336 202.5 336 176C336 149.5 357.5 128 384 128C410.5 128 432 149.5 432 176C432 202.5 410.5 224 384 224zM400 176C400 167.2 392.8 160 384 160C375.2 160 368 167.2 368 176C368 184.8 375.2 192 384 192C392.8 192 400 184.8 400 176zM224 224C197.5 224 176 202.5 176 176C176 149.5 197.5 128 224 128C250.5 128 272 149.5 272 176C272 202.5 250.5 224 224 224zM240 176C240 167.2 232.8 160 224 160C215.2 160 208 167.2 208 176C208 184.8 215.2 192 224 192C232.8 192 240 184.8 240 176zM64 128C90.51 128 112 149.5 112 176C112 202.5 90.51 224 64 224C37.49 224 16 202.5 16 176C16 149.5 37.49 128 64 128zM48 176C48 184.8 55.16 192 64 192C72.84 192 80 184.8 80 176C80 167.2 72.84 160 64 160C55.16 160 48 167.2 48 176zM384 384C357.5 384 336 362.5 336 336C336 309.5 357.5 288 384 288C410.5 288 432 309.5 432 336C432 362.5 410.5 384 384 384zM400 336C400 327.2 392.8 320 384 320C375.2 320 368 327.2 368 336C368 344.8 375.2 352 384 352C392.8 352 400 344.8 400 336zM224 288C250.5 288 272 309.5 272 336C272 362.5 250.5 384 224 384C197.5 384 176 362.5 176 336C176 309.5 197.5 288 224 288zM208 336C208 344.8 215.2 352 224 352C232.8 352 240 344.8 240 336C240 327.2 232.8 320 224 320C215.2 320 208 327.2 208 336zM64 384C37.49 384 16 362.5 16 336C16 309.5 37.49 288 64 288C90.51 288 112 309.5 112 336C112 362.5 90.51 384 64 384zM80 336C80 327.2 72.84 320 64 320C55.16 320 48 327.2 48 336C48 344.8 55.16 352 64 352C72.84 352 80 344.8 80 336z" />
        if (item == "check_matris_multi") icon = <path d="M448 376C448 398.1 430.1 416 408 416H360C337.9 416 320 398.1 320 376V328C320 305.9 337.9 288 360 288H408C430.1 288 448 305.9 448 328V376zM416 376V328C416 323.6 412.4 320 408 320H360C355.6 320 352 323.6 352 328V376C352 380.4 355.6 384 360 384H408C412.4 384 416 380.4 416 376zM448 184C448 206.1 430.1 224 408 224H360C337.9 224 320 206.1 320 184V136C320 113.9 337.9 96 360 96H408C430.1 96 448 113.9 448 136V184zM416 184V136C416 131.6 412.4 128 408 128H360C355.6 128 352 131.6 352 136V184C352 188.4 355.6 192 360 192H408C412.4 192 416 188.4 416 184zM200 416C177.9 416 160 398.1 160 376V328C160 305.9 177.9 288 200 288H248C270.1 288 288 305.9 288 328V376C288 398.1 270.1 416 248 416H200zM200 384H248C252.4 384 256 380.4 256 376V328C256 323.6 252.4 320 248 320H200C195.6 320 192 323.6 192 328V376C192 380.4 195.6 384 200 384zM288 184C288 206.1 270.1 224 248 224H200C177.9 224 160 206.1 160 184V136C160 113.9 177.9 96 200 96H248C270.1 96 288 113.9 288 136V184zM256 184V136C256 131.6 252.4 128 248 128H200C195.6 128 192 131.6 192 136V184C192 188.4 195.6 192 200 192H248C252.4 192 256 188.4 256 184zM40 416C17.91 416 0 398.1 0 376V328C0 305.9 17.91 288 40 288H88C110.1 288 128 305.9 128 328V376C128 398.1 110.1 416 88 416H40zM40 384H88C92.42 384 96 380.4 96 376V328C96 323.6 92.42 320 88 320H40C35.58 320 32 323.6 32 328V376C32 380.4 35.58 384 40 384zM128 184C128 206.1 110.1 224 88 224H40C17.91 224 0 206.1 0 184V136C0 113.9 17.91 96 40 96H88C110.1 96 128 113.9 128 136V184zM96 184V136C96 131.6 92.42 128 88 128H40C35.58 128 32 131.6 32 136V184C32 188.4 35.58 192 40 192H88C92.42 192 96 188.4 96 184z" />
        if (item == "text") icon = <path d="M0 48l0 96C0 152.8 7.156 160 16 160S32 152.8 32 144V64h144v384h-64C103.2 448 96 455.2 96 464S103.2 480 112 480h160C280.8 480 288 472.8 288 464S280.8 448 272 448h-64V64H352v80C352 152.8 359.2 160 368 160S384 152.8 384 144v-96C384 39.16 376.8 32 368 32h-352C7.156 32 0 39.16 0 48zM320 240v64c0 8.844 7.156 16 16 16S352 312.8 352 304V256h112v192H416c-8.844 0-16 7.156-16 16S407.2 480 416 480h128c8.844 0 16-7.156 16-16S552.8 448 544 448h-48V256H608v48c0 8.844 7.156 16 16 16S640 312.8 640 304v-64C640 231.2 632.8 224 624 224h-288C327.2 224 320 231.2 320 240z" />
        if (item == "memo") icon = <path d="M112 320h224c8.836 0 16-7.164 16-16C352 295.2 344.8 288 336 288h-224C103.2 288 96 295.2 96 304C96 312.8 103.2 320 112 320zM112 224h224C344.8 224 352 216.8 352 208C352 199.2 344.8 192 336 192h-224C103.2 192 96 199.2 96 208C96 216.8 103.2 224 112 224zM112 416h128c8.836 0 16-7.164 16-16c0-8.838-7.164-16-16-16h-128C103.2 384 96 391.2 96 400C96 408.8 103.2 416 112 416zM384 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V64C448 28.65 419.3 0 384 0zM416 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V128h384V448zM416 96H32V64c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32V96z" />
        if (item == "chart-pie") icon = <path d="M304 240V16.58C304 7.555 310.1 0 320 0C443.7 0 544 100.3 544 224C544 233 536.4 240 527.4 240H304zM493.1 192C479.1 120.5 423.5 64.04 352 50.9V192H493.1zM256 49.61V288L412.5 444.5C419.2 451.2 418.7 462.2 411 467.7C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272C32 150.7 122.1 50.34 238.1 34.25C248.2 32.99 256 40.36 256 49.61V49.61zM208 307.9V90.91C133.4 117.3 80 188.4 80 272C80 378 165.1 464 272 464C299.2 464 324.1 458.4 348.4 448.2L208 307.9zM558.4 288C567.6 288 575 295.8 573.8 305C566.1 360.9 539.1 410.6 499.9 447.3C493.9 452.1 484.5 452.5 478.7 446.7L320 288H558.4z" />
        if (item == "file-chart-pie") icon = <path d="M176 224v96c0 8.844 7.156 16 16 16h96c8.844 0 16-7.156 16-16c0-61.75-50.25-112-112-112C183.2 208 176 215.2 176 224zM208 241.6C239.3 247.1 264 272.7 270.4 304H208V241.6zM184 408c-44.13 0-80-35.88-80-80c0-32.7 19.81-60.74 48-73.1V221.4C105.9 235.3 72 277.5 72 328c0 61.75 50.25 112 112 112c50.53 0 92.73-33.89 106.6-80h-33.45C244.7 388.2 216.7 408 184 408zM365.3 125.3l-106.5-106.5C246.7 6.742 230.5 0 213.5 0H64C28.65 0 0 28.65 0 64l.0065 384c0 35.35 28.65 64 64 64H320c35.35 0 64-28.65 64-64V170.5C384 153.5 377.3 137.3 365.3 125.3zM224 34.08c4.477 1.566 8.666 3.846 12.12 7.299l106.5 106.5C346.1 151.3 348.4 155.5 349.9 160H240C231.2 160 224 152.8 224 144V34.08zM352 448c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h128v112C192 170.5 213.5 192 240 192H352V448z" />
        if (item == "eye") icon = <path d="M416 256C416 326.7 358.7 384 288 384C217.3 384 160 326.7 160 256C160 185.3 217.3 128 288 128C358.7 128 416 185.3 416 256zM288 160C234.1 160 192 202.1 192 256C192 309 234.1 352 288 352C341 352 384 309 384 256C384 202.1 341 160 288 160zM480.6 112.6C527.4 156 558.7 207.1 573.5 243.7C576.8 251.6 576.8 260.4 573.5 268.3C558.7 304 527.4 355.1 480.6 399.4C433.5 443.2 368.8 480 288 480C207.2 480 142.5 443.2 95.42 399.4C48.62 355.1 17.34 304 2.461 268.3C-.8205 260.4-.8205 251.6 2.461 243.7C17.34 207.1 48.62 156 95.42 112.6C142.5 68.84 207.2 32 288 32C368.8 32 433.5 68.84 480.6 112.6V112.6zM32 256C45.33 288 74.13 336 117.2 376C160.3 416 217.6 448 288 448C358.4 448 415.7 416 458.8 376C501.9 336 530.7 288 544 256C530.7 223.1 501.9 175.1 458.8 136C415.7 95.99 358.4 64 288 64C217.6 64 160.3 95.99 117.2 136C74.13 175.1 45.33 223.1 32 256V256z" />
        if (item == "sort") icon = <path d="M287.1 288h-255.9c-28.36 0-42.73 34.5-22.62 54.63l127.1 128c12.5 12.5 32.86 12.5 45.36 0l127.1-128C330.7 322.5 316.3 288 287.1 288zM160 448L32.05 320h255.9L160 448zM32.05 224h255.9c28.36 0 42.73-34.5 22.62-54.62l-127.1-128c-12.5-12.5-32.86-12.5-45.36 0L9.304 169.4C-10.69 189.5 3.682 224 32.05 224zM160 63.97L287.1 192h-255.9L160 63.97z" />

        if (icon == null) return null;

        return <svg className={cls} viewBox="0 0 512 512">
            {icon}
        </svg>
    }
    //start questainer components
    jsonConverts(data) {
        if (!this.isNull(data.record)) {
            for (var i = 0; i < data.record.questions.length; i++) {
                data.record.questions[i].options = data.record.questions[i].options.sort((a, b) => a.position - b.position);

                data.record.questions[i].conditions = JSON.parse(data.record.questions[i].conditions);
                data.record.questions[i].cover = JSON.parse(data.record.questions[i].cover);

                if (data.record.questions[i].fieldType === 4) {
                    data.record.questions[i].columns = JSON.parse(data.record.questions[i].columns);
                    for (var j = 0; j < data.record.questions[i].options.length; j++) {
                        data.record.questions[i].options[j].value = JSON.parse(data.record.questions[i].options[j].value);
                    }
                }
                else data.record.questions[i].columns = '';

            }

            if (!this.isBlank(data.record.configs)) {
                data.record.configs = JSON.parse(data.record.configs);
            }
            else {
                data.record.configs = {
                    startButtonCaption: '',
                };
            }

            if (!this.isBlank(data.record.notifications)) {
                data.record.notifications = JSON.parse(data.record.notifications);
            } else {
                data.record.notifications = {
                    clientEmail: 0,
                    designerEmail: 0,
                    clientEmailContent: '',
                    designerEmailContent: '',
                    clientEmailSubject: '',
                    designerEmailSubject: '',
                };
            }

            if (!this.isBlank(data.record.finishPageCover)) {
                data.record.finishPageCover = JSON.parse(data.record.finishPageCover);
            } else {
                data.record.finishPageCover = {
                    s: '',
                    w: 0,
                    h: 0,
                };
            }

            if (!this.isBlank(data.record.startPageCover)) {
                data.record.startPageCover = JSON.parse(data.record.startPageCover);
            } else {
                data.record.startPageCover = {
                    s: '',
                    w: 0,
                    h: 0,
                };
            }

            if (!this.isBlank(data.record.style)) {
                data.record.style = JSON.parse(data.record.style);
            } else {
                data.record.style = {
                    question_color: '',
                    answer_color: '',
                    focus_color: '',
                    button_color: '',
                    button_background_color: '',
                    background_color: ''
                };
            }
        }

        data.record.questions = data.record.questions.sort((a, b) => (a.position - b.position));
        return data;
    }
    renderLastPage(record) {
        if (record.finishPageDisplay !== 1) return null;
        return <div className='flex flex-col space-y-4 p-8'>
            {!this.isBlank(record.finishPageCaption) && <p className='text-xl font-bold' style={{ "color": record.style.questionColor }}>{record.finishPageCaption}</p>}
            {!this.isBlank(record.finishPageCover.s) && <div className='text-center flex flex-col items-center'><img src={this.toImageUrl(record.finishPageCover, "questionnaire")} style={{ "width": record.finishPageCover.w + "px", "height": record.finishPageCover.h + "px" }} /></div>}
            {!this.isBlank(record.finishPageDescription) && <p className='text-l mt-4' style={{ "color": record.style.questionColor }} dangerouslySetInnerHTML={{ __html: record.finishPageDescription }}></p>}
        </div>
    }
    renderFirstPage(record, fromEditor = false) {
        if (record.startPageDisplay !== 1) {
            this.start();
            return null;
        }
        return <div>
            <div className='flex flex-col space-y-4 p-8'>
                {!this.isBlank(record.startPageCaption) && <p className='font-bold' style={{ "color": record.style.questionColor }}>{record.startPageCaption}</p>}
                {!this.isBlank(record.startPageCover.s) && <div className='text-center flex flex-col items-center'><img src={this.toImageUrl(record.startPageCover, "questionnaire")} style={{ "width": record.startPageCover.w + "px", "height": record.startPageCover.h + "px" }} /></div>}
                {!this.isBlank(record.startPageDescription) && <p className='text-l mt-4' style={{ "color": record.style.questionColor }} dangerouslySetInnerHTML={{ __html: record.startPageDescription }}></p>}
            </div>
            <div className="my-8 text-center">
                <span onClick={e => !fromEditor ? this.start() : null} style={{ "font-size": "1.1rem", "backgroundColor": record.style.button_background_color, "color": record.style.button_color }} className="hand btn btn-success">{this.isBlank(record.configs.startButtonCaption) ? "شروع تکمیل پرسشنامه" : record.configs.startButtonCaption}</span>
            </div>
        </div>
    }
    renderQuestionBox(question, fromEditor = false, style = {}) {
        var html = [];
        var rangeStart = null;
        var rangeEnd = null;

        var backgroundColor = "";
        var questionColor = "";
        var answerColor = "";
        var focusColor = "";
        var buttonColor = "";
        var buttonBackgroundColor = "";

        if (!this.isNull(style)) {
            backgroundColor = this.isBlank(style.backgroundColor) ? "" : style.backgroundColor;
            questionColor = this.isBlank(style.questionColor) ? "" : style.questionColor;
            answerColor = this.isBlank(style.answerColor) ? "" : style.answerColor;
            focusColor = this.isBlank(style.focusColor) ? "" : style.focusColor;
            buttonColor = this.isBlank(style.buttonColor) ? "" : style.buttonColor;
            buttonBackgroundColor = this.isBlank(style.buttonBackgroundColor) ? "" : style.buttonBackgroundColor;
        }

        if (question.range.includes(";")) {
            var parts = question.range.split(";");
            if (!isNaN(parts[0])) rangeStart = parts[0];
            if (!isNaN(parts[1])) rangeEnd = parts[1];
        }

        if (!this.isBlank(question.cover.s)) {
            html.push(<div className='text-center flex flex-col items-center'><img src={this.toImageUrl(question.cover, "questionnaire")} style={{ "width": question.cover.w + "px", "height": question.cover.h + "px" }} /></div>)
        }

        if (question.fieldType !== 7) {
            html.push(<div className='mb-2' style={{ "color": questionColor }}>
                <div className='flex'>
                    {question.required === 1 ? <span className='text-red-400'>* </span> : null}{question.showNumber == 1 ? question.position + ". " : ""}
                    <p className='font-bold' dangerouslySetInnerHTML={{ __html: question.question }}></p>
                </div>
                <small>{question.questionDesc}</small>
            </div>);
        }

        if (question.fieldType === 1) {
            html.push(<div>
                {question.format == 1 &&
                    <textarea
                        type="text"
                        style={{ "color": answerColor, "height": "160px" }}
                        defaultValue={fromEditor ? null : this.getAnswer(question, null, null).textValue}
                        onChange={e => fromEditor == false ? this.setAnswer(question, null, null, { text: e.target.value, value: null }) : null}
                        className={"focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full p-2 rounded"}></textarea>
                }
                {question.format == 2 &&
                    <input
                        type="number"
                        style={{ "color": answerColor }}
                        min={rangeStart}
                        max={rangeEnd}
                        defaultValue={fromEditor ? null : this.getAnswer(question, null, null).numberValue}
                        onChange={e => fromEditor == false ? this.setAnswer(question, null, null, { text: null, value: e.target.value }) : null}
                        className={"form-control"} />
                }
                {question.format == 3 &&
                    <input
                        type="number"
                        style={{ "color": answerColor }}
                        min={rangeStart}
                        max={rangeEnd}
                        defaultValue={fromEditor ? null : this.getAnswer(question, null, null).numberValue}
                        onChange={e => fromEditor == false ? this.setAnswer(question, null, null, { text: null, value: e.target.value }) : null}
                        className={"form-control"} />
                }
                {question.format == 4 &&
                    <input
                        type="email"
                        style={{ "color": answerColor }}
                        defaultValue={fromEditor ? null : this.getAnswer(question, null, null).textValue}
                        onChange={e => fromEditor == false ? this.setAnswer(question, null, null, { text: e.target.value, value: null }) : null}
                        className={"form-control"} />
                }
                {question.format == 5 &&
                    <InputMask
                        mask={"0\\9999999999"}
                        style={{ "color": answerColor }}
                        maskChar=""
                        defaultValue={fromEditor ? null : this.getAnswer(question, null, null).textValue}
                        onChange={e => fromEditor == false ? this.setAnswer(question, null, null, { text: e.target.value, value: null }) : null}
                        className={"border-1 ltr form-control"} />
                }
                {question.format == 6 &&
                    <input
                        type="text"
                        style={{ "color": answerColor }}
                        defaultValue={fromEditor ? null : this.getAnswer(question, null, null).textValue}
                        onChange={e => fromEditor == false ? this.setAnswer(question, null, null, { text: e.target.value, value: null }) : null}
                        className={"ltr form-control"} />
                }
                {question.format == 7 &&
                    <InputMask
                        mask={"9999999999"}
                        style={{ "color": answerColor }}
                        maskChar=""
                        defaultValue={fromEditor ? null : this.getAnswer(question, null, null).textValue}
                        onChange={e => fromEditor == false ? this.setAnswer(question, null, null, { text: e.target.value, value: null }) : null}
                        className={"border-1 ltr form-control"} />
                }
                {question.format == 8 &&
                    <DatePicker
                        className={"calendarContainerForQ focus:border-brand dark:focus:border-brand-dark dark:border-light-700  bg-transparent border-gray-300 p-2 rounded"}
                        inputReadOnly={true}
                        style={{ "color": answerColor }}
                        placeholder={""}
                        isGregorian={false}
                        showTodayButton={true}
                        timePicker={false}
                        onChange={e => fromEditor == false ? this.setPersianDateAnswer(question, null, null, e) : null}
                    />
                }
                {question.format == 9 &&
                    <DatePicker
                        className={"calendarContainerForQ focus:border-brand dark:focus:border-brand-dark dark:border-light-700  bg-transparent border-gray-300 p-2 rounded"}
                        inputReadOnly={true}
                        style={{ "color": answerColor }}
                        placeholder={""}
                        isGregorian={true}
                        showTodayButton={true}
                        timePicker={false}
                        onChange={e => fromEditor == false ? this.setEnglishDateAnswer(question, null, null, e) : null}
                    />
                }
                {question.format == 10 &&
                    <InputMask
                        mask={"999.999.999.999"}
                        style={{ "color": answerColor }}
                        maskChar=""
                        defaultValue={fromEditor ? null : this.getAnswer(question, null, null).textValue}
                        onChange={e => fromEditor == false ? this.setAnswer(question, null, null, { text: e.target.value, value: null }) : null}
                        className={"border-1 ltr form-control"} />
                }
                {question.format == 11 &&
                    <input
                        type="file"
                        style={{ "color": answerColor }}
                        // defaultValue={fromEditor ? null : this.getAnswer(question,null,null).numberValue}
                        onChange={e => fromEditor == false ? this.setFileAnswer(question, null, null, e) : null}
                        className={"form-control"} />
                }
            </div>);
        }

        if (question.fieldType === 2) {
            if (question.format == 1 || question.format == 2) {
                question.options.forEach((op, index) => {
                    html.push(<div key={op.id} className="flex flex-row mb-2" style={{ "color": answerColor }}>
                        <p><input defaultChecked={fromEditor ? null : this.getAnswer(question, op, null).textValue === "1"} onChange={e => this.setAnswer(question, op, null, { text: (e.target.checked ? "1" : null), value: (e.target.checked ? (question.pointEnable == 1 ? op.value : null) : null) })} type={question.format == 1 ? "radio" : "checkbox"} name={"q_" + question.id} className="focus:border-brand focus:ring-0 focus:border-b-2 dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 mx-2" /> {op.text}</p>
                    </div>);
                });
            }

            if (question.format == 3) {
                html.push(<Select
                    style={{ "color": answerColor }}
                    className="autocomplete focus:border-brand focus:ring-0 focus:border-b-2 dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300"
                    isMulti={true}
                    placeholder="انتخاب کنید"
                    noOptionsMessage={() => 'موردی یافت نشد'}
                    loadingMessage={() => 'در حال جستجو'}
                    options={this.loadQuestionDropDownItems(question)}
                    isOptionDisabled={() => fromEditor ? false : this.isNull(this.getAnswer(question, null, null)) ? false : this.isNull(this.getAnswer(question, null, null).array_object) ? false : this.getAnswer(question, null, null).array_object.length >= question.maxSelect}
                    defaultValue={() => fromEditor ? null : this.isNull(this.getAnswer(question, null, null)) ? null : this.isNull(this.getAnswer(question, null, null).array_object) ? null : this.getAnswer(question, null, null).array_object}
                    onChange={e => this.setAnswer(question, null, null, e)}
                />);
            }

            if (question.format == 4) {
                question.options.forEach((op, index) => {
                    html.push(<div key={op.id} className="flex flex-row mb-2" style={{ "color": answerColor }}>
                        <p>{op.text}</p>
                        <input defaultValue={fromEditor ? null : this.getAnswer(question, op, null).textValue} onChange={e => this.setAnswer(question, op, null, { text: e.target.value, value: null })} type={"text"} className="focus:border-brand focus:ring-0 focus:border-b-2 dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 mx-2" />
                    </div>);
                });
            }

            if (question.format == 5) {
                question.options.forEach((op, index) => {
                    html.push(<div key={op.id} className="flex flex-row mb-2" style={{ "color": answerColor }}>
                        <p>{op.text}</p>
                        <input
                            defaultValue={fromEditor ? null : this.getAnswer(question, op, null).tnumberValue}
                            onChange={e => this.setAnswer(question, op, null, { text: null, value: e.target.value })}
                            min={rangeStart}
                            max={rangeEnd}
                            type={"number"}
                            className="focus:border-brand focus:ring-0 focus:border-b-2 dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 mx-2" />
                    </div>);
                });
            }
            if (question.format == 6) {
                question.options.forEach((op, index) => {
                    html.push(<div key={op.id} className="flex flex-row mb-2" style={{ "color": answerColor }}>
                        <p><input defaultChecked={fromEditor ? null : this.getAnswer(question, op, null).textValue === "1"} onChange={e => this.setAnswer(question, op, null, { text: (e.target.checked ? "1" : null), value: (e.target.checked ? (question.pointEnable == 1 ? op.value : null) : null) })} type={"radio"} name={"q_" + question.id} className="mx-2" style={{ "background-image": "url('https://domain.com/media/avatars/" + (this.isBlank(op.avatar) ? "_default.svg" : op.avatar) + "')", "background-color": "white", "width": "4rem", "height": "4rem", "background-size": "80%", "background-repeat": "no-repeat", "background-position": "center center" }} />{op.text}</p>
                    </div>);
                });
            }
        }

        if (question.fieldType === 4) {
            var head = [];
            var body = [];

            var columns = question.columns;
            head.push(<th className='p-1' style={{ "font-size": "1rem", "line-height": "2rem" }}></th>);
            if (columns.sort != undefined) {
                columns.sort((a, b) => a.position - b.position).forEach(c => {
                    head.push(<th className='p-1' style={{ "font-size": "1rem", "line-height": "2rem", "color": questionColor }}>{c.caption}</th>);
                });
            }

            question.options.forEach((op, index) => {
                var row = [];
                row.push(<td className='p-1' style={{ "font-size": "1rem", "line-height": "2rem", "color": questionColor }}><p>{op.text}</p></td>);
                if (columns.sort != undefined) {
                    columns.sort((a, b) => a.position - b.position).forEach(c => {
                        if (question.format == 1 || question.format == 2) row.push(<td className='p-1'><input defaultChecked={fromEditor ? null : this.getAnswer(question, op, c.id).textValue === "1"} onChange={e => this.setAnswer(question, op, c.id, { text: (e.target.checked ? "1" : null), value: (e.target.checked ? (question.pointEnable == 1 ? op.value : null) : null) })} type={question.format == 1 ? "radio" : "checkbox"} name={"o_" + op.id} className="focus:border-brand focus:ring-0 focus:border-b-2 dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 mx-2" /></td>);
                        if (question.format == 4) row.push(<td className='p-1'><input defaultValue={fromEditor ? null : this.getAnswer(question, op, c.id).textValue} onChange={e => this.setAnswer(question, op, c.id, { text: e.target.value, value: null })} min={rangeStart} type={"text"} className="w-36 focus:border-brand focus:ring-0 focus:border-b-2 dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300" /></td>);
                        if (question.format == 5) row.push(<td className='p-1'><input defaultValue={fromEditor ? null : this.getAnswer(question, op, c.id).numberValue} onChange={e => this.setAnswer(question, op, c.id, { text: '', value: e.target.value })} type={"number"} className="w-36 focus:border-brand focus:ring-0 focus:border-b-2 dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300" /></td>);
                    });
                }
                body.push(<tr>{row}</tr>);
            });

            html.push(<table className='text-center' style={{ "color": answerColor }}>
                <thead><tr>{head}</tr></thead>
                <tbody>{body}</tbody>
            </table>)
        }

        if (question.fieldType === 7) {
            html.push(<div style={{ "color": questionColor }} dangerouslySetInnerHTML={{ __html: question.questionDesc }}></div>);
        }

        var footer = null;

        if (fromEditor == false && this.state.data.record.status !== 2) {
            if (this.state.data.record.displayMode == 1) {
                footer = <div className={"text-center border border-b-0 border-l-0 border-r-0 right-0 bottom-0 p-2 w-full bg-white absolute flex md:block items-center " + (this.state.embeded ? "fixed" : "absolute")} style={{ "place-content": "center", "line-height": "1.6rem", "position": "fixed", "bottom": "0","left":"0", "background-color": backgroundColor, "color": questionColor }}>
                    {this.state.data.record.prevButton == 1 && <span onClick={e => this.prevQuestion()} className="hand btn btn-warning" title={this.state.currentQuestionPosition === 0 ? 'مرحله قبلی' : ' سوال قبلی'} style={{ "font-size": "1rem", "backgroundColor": buttonBackgroundColor, "color": buttonColor }}> {this.state.currentQuestionPosition === 0 ? 'مرحله قبلی' : ' سوال قبلی'} </span>}
                    {this.state.data.record.showQuestionCount === 1 && <span className='mx-2 text-xs' style={{ "color": questionColor }}> سوال <b>{this.state.currentQuestionPosition + 1}</b> از مجموع <b>{this.state.data.record.questions.length}</b> سوال </span>}
                    {this.state.data.record.nextButton == 1 && <span onClick={e => this.nextQuestion()} className="hand btn btn-success" title='سوال بعدی' style={{ "font-size": "1rem", "backgroundColor": buttonBackgroundColor, "color": buttonColor }}> سوال بعدی </span>}
                </div>
            }
            if (this.state.data.record.displayMode == 2) {
                footer = <div className={"text-center border border-b-0 border-l-0 border-r-0 right-0 bottom-0 p-2 w-full bg-white absolute flex md:block items-center " + (this.state.embeded ? "fixed" : "absolute")} style={{ "place-content": "center", "line-height": "1.6rem", "position": "fixed", "bottom": "0", "left": "0", "backgroundColor": backgroundColor, "color": questionColor }}>
                    {this.state.data.record.showQuestionCount === 1 && <span className='mx-2 text-xs' style={{ "color": questionColor }}> تعداد سوالات: <b>{this.state.data.record.questions.length}</b> سوال </span>}
                    {this.state.data.record.nextButton == 1 && <span onClick={e => this.nextQuestion()} className="hand btn btn-success" title='مرحله بعدی' style={{ "font-size": "1rem", "backgroundColor": buttonBackgroundColor, "color": buttonColor }}> مرحله بعدی </span>}
                </div>
            }
        }

        return <div id="Questionnaire" style={{ "font-size": "1.2rem", "line-height": "2.8rem", "width": "100%", "max-width": "45rem", "margin": "0 auto", "padding": "2rem 0" }}>
                {fromEditor && this.state.data.record.titleDisplay == 1 && <p className='text-center text-xl pt-4 font-bold' style={{ "color": questionColor }}>{this.state.data.record.title}</p>}
                <div key={question.id} className={fromEditor ? "p-4" : ""}>
                    {html}
                </div>
                {footer}
            </div>
    }
    toImageUrl(record,id) {
        if (record === null || record === undefined) return "";
        if (this.isBlank(record.s)) return "";
        if (record.s.includes("data:image/")) return record.s;
        if (record.s) return "https://files.domain.com/media/q/" + id + "/" + record.s;
    }
    loadOrderingsOptions(inputValue, callback, type, status = -1) {
        var organizationId = window.organizationId;
        setTimeout(() => {
            fetch('/api/v1/common/getorderings/', {
                method: 'post',
                body: JSON.stringify({
                    term: inputValue,
                    organizationId,
                    companyId: organizationId,
                    type,
                    status
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((response) => {
                    let items = response.records;
                    callback(items);
                });
        }, 50);
    }
    numberToPersianWords(input) {
        if (input === null || input === undefined || input === '') return '';
        const str = String(input).replace(/\s+/g, '');
        if (isNaN(Number(str.replace(',', '.')))) return '';

        const parts = str.replace(/،/g, ',').split(/[.,]/);
        const intPart = parts[0] === '' ? '0' : parts[0];
        const decPart = parts.length > 1 ? parts.slice(1).join('') : null;

        const ones = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
        const teens = ['ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده'];
        const tens = ['', '', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
        const hundreds = ['', 'صد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];
        const scales = ['', 'هزار', 'میلیون', 'میلیارد', 'تریلیون', 'کوادریلیون'];

        const decimalUnits = [
            'دهم', 'صدم', 'هزارم', 'ده‌هزارم', 'صد‌هزارم', 'میلیونیم',
            'ده‌میلیونیم', 'صد‌میلیونیم', 'میلیاردیم'
        ];

        function threeDigitsToWords(numStr) {
            let n = Number(numStr);
            if (n === 0) return '';
            const h = Math.floor(n / 100);
            const t = Math.floor((n % 100) / 10);
            const o = n % 10;
            const parts = [];
            if (h > 0) parts.push(hundreds[h]);
            if (t === 1) parts.push(teens[o]);
            else {
                if (t > 1) parts.push(tens[t]);
                if (o > 0) parts.push(ones[o]);
            }
            return parts.join(' و ');
        }

        function integerToWords(intStr) {
            if (/^-/.test(intStr)) {
                return 'منفی ' + integerToWords(intStr.replace(/^-/, ''));
            }
            let s = intStr.replace(/^0+/, '');
            if (s === '') s = '0';
            if (s === '0') return 'صفر';

            const groups = [];
            while (s.length > 0) {
                groups.unshift(s.slice(-3));
                s = s.slice(0, -3);
            }

            const words = [];
            const gcount = groups.length;
            for (let i = 0; i < gcount; i++) {
                const grp = Number(groups[i]);
                if (grp === 0) continue;
                const grpWords = threeDigitsToWords(String(grp));
                const scaleIndex = gcount - 1 - i;
                const scaleWord = scales[scaleIndex] || '';
                words.push((grpWords + (scaleWord ? ' ' + scaleWord : '')).trim());
            }

            return words.join(' و ');
        }

        function decimalToWords(decStr) {
            const num = Number(decStr);
            if (num === 0) return '';
            const length = decStr.length;
            const unit = decimalUnits[length - 1] || `در ${Math.pow(10, length)}‌ام`;
            const numWords = integerToWords(decStr.replace(/^0+/, '') || '0');
            return `${numWords} ${unit}`;
        }

        const intWords = integerToWords(intPart);

        if (!decPart || /^0+$/.test(decPart)) {
            return intWords;
        } else {
            const decWords = decimalToWords(decPart);
            return `${intWords} و ${decWords}`;
        }
    }
}
